function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
let $8863cd8fe199f948$var$taskIdCounter = 1, $8863cd8fe199f948$var$isCallbackScheduled = false, $8863cd8fe199f948$var$isPerformingWork = false, $8863cd8fe199f948$var$taskQueue = [], $8863cd8fe199f948$var$currentTask = null, $8863cd8fe199f948$var$shouldYieldToHost = null, $8863cd8fe199f948$var$yieldInterval = 5, $8863cd8fe199f948$var$deadline = 0, $8863cd8fe199f948$var$maxYieldInterval = 300, $8863cd8fe199f948$var$scheduleCallback = null, $8863cd8fe199f948$var$scheduledCallback = null;
const $8863cd8fe199f948$var$maxSigned31BitInt = 1073741823;
function $8863cd8fe199f948$var$setupScheduler() {
    const channel = new MessageChannel(), port = channel.port2;
    $8863cd8fe199f948$var$scheduleCallback = ()=>port.postMessage(null);
    channel.port1.onmessage = ()=>{
        if ($8863cd8fe199f948$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $8863cd8fe199f948$var$deadline = currentTime + $8863cd8fe199f948$var$yieldInterval;
            const hasTimeRemaining = true;
            try {
                const hasMoreWork = $8863cd8fe199f948$var$scheduledCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) $8863cd8fe199f948$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $8863cd8fe199f948$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $8863cd8fe199f948$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $8863cd8fe199f948$var$maxYieldInterval;
            } else return false;
        };
    } else $8863cd8fe199f948$var$shouldYieldToHost = ()=>performance.now() >= $8863cd8fe199f948$var$deadline;
}
function $8863cd8fe199f948$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $8863cd8fe199f948$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$8863cd8fe199f948$var$scheduleCallback) $8863cd8fe199f948$var$setupScheduler();
    let startTime = performance.now(), timeout = $8863cd8fe199f948$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $8863cd8fe199f948$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $8863cd8fe199f948$var$enqueue($8863cd8fe199f948$var$taskQueue, newTask);
    if (!$8863cd8fe199f948$var$isCallbackScheduled && !$8863cd8fe199f948$var$isPerformingWork) {
        $8863cd8fe199f948$var$isCallbackScheduled = true;
        $8863cd8fe199f948$var$scheduledCallback = $8863cd8fe199f948$var$flushWork;
        $8863cd8fe199f948$var$scheduleCallback();
    }
    return newTask;
}
function $8863cd8fe199f948$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $8863cd8fe199f948$var$flushWork(hasTimeRemaining, initialTime) {
    $8863cd8fe199f948$var$isCallbackScheduled = false;
    $8863cd8fe199f948$var$isPerformingWork = true;
    try {
        return $8863cd8fe199f948$var$workLoop(hasTimeRemaining, initialTime);
    } finally{
        $8863cd8fe199f948$var$currentTask = null;
        $8863cd8fe199f948$var$isPerformingWork = false;
    }
}
function $8863cd8fe199f948$var$workLoop(hasTimeRemaining, initialTime) {
    let currentTime = initialTime;
    $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    while($8863cd8fe199f948$var$currentTask !== null){
        if ($8863cd8fe199f948$var$currentTask.expirationTime > currentTime && (!hasTimeRemaining || $8863cd8fe199f948$var$shouldYieldToHost())) break;
        const callback = $8863cd8fe199f948$var$currentTask.fn;
        if (callback !== null) {
            $8863cd8fe199f948$var$currentTask.fn = null;
            const didUserCallbackTimeout = $8863cd8fe199f948$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($8863cd8fe199f948$var$currentTask === $8863cd8fe199f948$var$taskQueue[0]) $8863cd8fe199f948$var$taskQueue.shift();
        } else $8863cd8fe199f948$var$taskQueue.shift();
        $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    }
    return $8863cd8fe199f948$var$currentTask !== null;
}
const $8863cd8fe199f948$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined
};
function $8863cd8fe199f948$var$setHydrateContext(context) {
    $8863cd8fe199f948$export$2cb4986bed338027.context = context;
}
function $8863cd8fe199f948$var$nextHydrateContext() {
    return {
        ...$8863cd8fe199f948$export$2cb4986bed338027.context,
        id: `${$8863cd8fe199f948$export$2cb4986bed338027.context.id}${$8863cd8fe199f948$export$2cb4986bed338027.context.count++}-`,
        count: 0
    };
}
const $8863cd8fe199f948$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $8863cd8fe199f948$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $8863cd8fe199f948$export$17a675b7c02a7b1d = Symbol("solid-track");
const $8863cd8fe199f948$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $8863cd8fe199f948$var$signalOptions = {
    equals: $8863cd8fe199f948$export$34b67c27f2ca7498
};
let $8863cd8fe199f948$var$ERROR = null;
let $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runQueue;
const $8863cd8fe199f948$var$STALE = 1;
const $8863cd8fe199f948$var$PENDING = 2;
const $8863cd8fe199f948$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $8863cd8fe199f948$var$NO_INIT = {};
var $8863cd8fe199f948$var$Owner = null;
let $8863cd8fe199f948$var$Transition = null;
let $8863cd8fe199f948$var$Scheduler = null;
let $8863cd8fe199f948$var$ExternalSourceFactory = null;
let $8863cd8fe199f948$var$Listener = null;
let $8863cd8fe199f948$var$Updates = null;
let $8863cd8fe199f948$var$Effects = null;
let $8863cd8fe199f948$var$ExecCount = 0;
const [$8863cd8fe199f948$var$transPending, $8863cd8fe199f948$var$setTransPending] = /*@__PURE__*/ $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false);
function $8863cd8fe199f948$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $8863cd8fe199f948$var$Listener, owner = $8863cd8fe199f948$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $8863cd8fe199f948$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(()=>$8863cd8fe199f948$var$cleanNode(root)));
    $8863cd8fe199f948$var$Owner = root;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(updateFn, true);
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
        $8863cd8fe199f948$var$Owner = owner;
    }
}
function $8863cd8fe199f948$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $8863cd8fe199f948$var$writeSignal(s, value);
    };
    return [
        $8863cd8fe199f948$var$readSignal.bind(s),
        setter
    ];
}
function $8863cd8fe199f948$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$314dade334ae905d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$7ea7134f704deda4(fn, value, options) {
    $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runUserEffects;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $8863cd8fe199f948$var$Effects ? $8863cd8fe199f948$var$Effects.push(c) : $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $8863cd8fe199f948$var$createComputation(()=>{
        fn ? fn() : $8863cd8fe199f948$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $8863cd8fe199f948$var$updateComputation(c);
    };
}
function $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.tState = $8863cd8fe199f948$var$STALE;
        $8863cd8fe199f948$var$Updates.push(c);
    } else $8863cd8fe199f948$var$updateComputation(c);
    return $8863cd8fe199f948$var$readSignal.bind(c);
}
function $8863cd8fe199f948$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (arguments.length === 2 && typeof pFetcher === "object" || arguments.length === 1) {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    } else {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    }
    let pr = null, initP = $8863cd8fe199f948$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        id = `${$8863cd8fe199f948$export$2cb4986bed338027.context.id}${$8863cd8fe199f948$export$2cb4986bed338027.context.count++}`;
        let v;
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($8863cd8fe199f948$export$2cb4986bed338027.load && (v = $8863cd8fe199f948$export$2cb4986bed338027.load(id))) initP = v[0];
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $8863cd8fe199f948$var$NO_INIT;
            if ($8863cd8fe199f948$var$Transition && p && loadedUnderTransition) {
                $8863cd8fe199f948$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $8863cd8fe199f948$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($8863cd8fe199f948$var$Listener && !$8863cd8fe199f948$var$Listener.user && c) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $8863cd8fe199f948$var$Transition && loadedUnderTransition) $8863cd8fe199f948$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $8863cd8fe199f948$export$363ebc4b78b8f807(value));
            return;
        }
        if ($8863cd8fe199f948$var$Transition && pr) $8863cd8fe199f948$var$Transition.promises.delete(pr);
        const p = initP !== $8863cd8fe199f948$var$NO_INIT ? initP : $8863cd8fe199f948$export$363ebc4b78b8f807(()=>fetcher(lookup, {
                value: value(),
                refetching: refetching
            }));
        if (typeof p !== "object" || !(p && "then" in p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $8863cd8fe199f948$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $8863cd8fe199f948$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    if (dynamic) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>load(false));
    else load(false);
    return [
        read,
        {
            refetch: load,
            mutate: setValue
        }
    ];
}
function $8863cd8fe199f948$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $8863cd8fe199f948$var$createComputation(()=>{
        if (!t || !t.fn) t = $8863cd8fe199f948$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(node.value, options);
    $8863cd8fe199f948$var$updateComputation(node);
    setDeferred(()=>node.value);
    return deferred;
}
function $8863cd8fe199f948$export$595d22ed68ca2841(source, fn = $8863cd8fe199f948$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $8863cd8fe199f948$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            c.state = $8863cd8fe199f948$var$STALE;
            if (c.pure) $8863cd8fe199f948$var$Updates.push(c);
            else $8863cd8fe199f948$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $8863cd8fe199f948$var$STALE);
    $8863cd8fe199f948$var$updateComputation(node);
    return (key)=>{
        const listener = $8863cd8fe199f948$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $8863cd8fe199f948$export$712ea50be43a7858(fn) {
    return $8863cd8fe199f948$var$runUpdates(fn, false);
}
function $8863cd8fe199f948$export$363ebc4b78b8f807(fn) {
    if ($8863cd8fe199f948$var$Listener === null) return fn();
    const listener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return fn();
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
    }
}
function $8863cd8fe199f948$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return undefined;
        }
        const result = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $8863cd8fe199f948$export$1e848a9e87980bd5(fn) {
    $8863cd8fe199f948$export$7ea7134f704deda4(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(fn));
}
function $8863cd8fe199f948$export$b36e5eaa3e8c43ab(fn) {
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.cleanups === null) $8863cd8fe199f948$var$Owner.cleanups = [
        fn
    ];
    else $8863cd8fe199f948$var$Owner.cleanups.push(fn);
    return fn;
}
function $8863cd8fe199f948$export$3dede90624df3ba9(fn, handler) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$createComputation(undefined, undefined, true);
    $8863cd8fe199f948$var$Owner.context = {
        ...$8863cd8fe199f948$var$Owner.context,
        [$8863cd8fe199f948$var$ERROR]: [
            handler
        ]
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Transition.sources.add($8863cd8fe199f948$var$Owner);
    try {
        return fn();
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$Owner.owner;
    }
}
function $8863cd8fe199f948$export$12abb5141c6fdc9c() {
    return $8863cd8fe199f948$var$Listener;
}
function $8863cd8fe199f948$export$5f4ed0d56c2c0edf() {
    return $8863cd8fe199f948$var$Owner;
}
function $8863cd8fe199f948$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $8863cd8fe199f948$var$Owner;
    const prevListener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Owner = o;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(fn, true);
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = prev;
        $8863cd8fe199f948$var$Listener = prevListener;
    }
}
function $8863cd8fe199f948$export$45e8540700504e87(scheduler = $8863cd8fe199f948$export$4b5e076b3a2fbe0a) {
    $8863cd8fe199f948$var$Scheduler = scheduler;
}
function $8863cd8fe199f948$export$7568632d0d33d16d(fn) {
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        fn();
        return $8863cd8fe199f948$var$Transition.done;
    }
    const l = $8863cd8fe199f948$var$Listener;
    const o = $8863cd8fe199f948$var$Owner;
    return Promise.resolve().then(()=>{
        $8863cd8fe199f948$var$Listener = l;
        $8863cd8fe199f948$var$Owner = o;
        let t;
        if ($8863cd8fe199f948$var$Scheduler || $8863cd8fe199f948$var$SuspenseContext) {
            t = $8863cd8fe199f948$var$Transition || ($8863cd8fe199f948$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $8863cd8fe199f948$var$runUpdates(fn, false);
        $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        return t ? t.done : undefined;
    });
}
function $8863cd8fe199f948$export$7b286972b8d8ccbf() {
    return [
        $8863cd8fe199f948$var$transPending,
        $8863cd8fe199f948$export$7568632d0d33d16d
    ];
}
function $8863cd8fe199f948$var$resumeEffects(e) {
    $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, e);
    e.length = 0;
}
function $8863cd8fe199f948$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $8863cd8fe199f948$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $8863cd8fe199f948$export$fae74005e78b1a27(context) {
    return $8863cd8fe199f948$var$Owner && $8863cd8fe199f948$var$Owner.context && $8863cd8fe199f948$var$Owner.context[context.id] !== undefined ? $8863cd8fe199f948$var$Owner.context[context.id] : context.defaultValue;
}
function $8863cd8fe199f948$export$bacb5cc5a11aef16(fn) {
    const children = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn);
    const memo = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>$8863cd8fe199f948$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $8863cd8fe199f948$var$SuspenseContext;
function $8863cd8fe199f948$var$getSuspenseContext() {
    return $8863cd8fe199f948$var$SuspenseContext || ($8863cd8fe199f948$var$SuspenseContext = $8863cd8fe199f948$export$fd42f52fd3ae1109());
}
function $8863cd8fe199f948$export$315ab94ce87a624f(factory) {
    if ($8863cd8fe199f948$var$ExternalSourceFactory) {
        const oldFactory = $8863cd8fe199f948$var$ExternalSourceFactory;
        $8863cd8fe199f948$var$ExternalSourceFactory = (fn, trigger)=>{
            const oldSource = oldFactory(fn, trigger);
            const source = factory((x)=>oldSource.track(x), trigger);
            return {
                track: (x)=>source.track(x),
                dispose () {
                    source.dispose();
                    oldSource.dispose();
                }
            };
        };
    } else $8863cd8fe199f948$var$ExternalSourceFactory = factory;
}
function $8863cd8fe199f948$var$readSignal() {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(this);
        else {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(this), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
    if ($8863cd8fe199f948$var$Listener) {
        const sSlot = this.observers ? this.observers.length : 0;
        if (!$8863cd8fe199f948$var$Listener.sources) {
            $8863cd8fe199f948$var$Listener.sources = [
                this
            ];
            $8863cd8fe199f948$var$Listener.sourceSlots = [
                sSlot
            ];
        } else {
            $8863cd8fe199f948$var$Listener.sources.push(this);
            $8863cd8fe199f948$var$Listener.sourceSlots.push(sSlot);
        }
        if (!this.observers) {
            this.observers = [
                $8863cd8fe199f948$var$Listener
            ];
            this.observerSlots = [
                $8863cd8fe199f948$var$Listener.sources.length - 1
            ];
        } else {
            this.observers.push($8863cd8fe199f948$var$Listener);
            this.observerSlots.push($8863cd8fe199f948$var$Listener.sources.length - 1);
        }
    }
    if (runningTransition && $8863cd8fe199f948$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $8863cd8fe199f948$var$writeSignal(node, value, isComp) {
    let current = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($8863cd8fe199f948$var$Transition) {
            const TransitionRunning = $8863cd8fe199f948$var$Transition.running;
            if (TransitionRunning || !isComp && $8863cd8fe199f948$var$Transition.sources.has(node)) {
                $8863cd8fe199f948$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $8863cd8fe199f948$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
                if (TransitionRunning && $8863cd8fe199f948$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
                    else $8863cd8fe199f948$var$Effects.push(o);
                    if (o.observers) $8863cd8fe199f948$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $8863cd8fe199f948$var$STALE;
                else o.tState = $8863cd8fe199f948$var$STALE;
            }
            if ($8863cd8fe199f948$var$Updates.length > 10e5) {
                $8863cd8fe199f948$var$Updates = [];
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $8863cd8fe199f948$var$updateComputation(node) {
    if (!node.fn) return;
    $8863cd8fe199f948$var$cleanNode(node);
    const owner = $8863cd8fe199f948$var$Owner, listener = $8863cd8fe199f948$var$Listener, time = $8863cd8fe199f948$var$ExecCount;
    $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
    $8863cd8fe199f948$var$runComputation(node, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($8863cd8fe199f948$var$Transition && !$8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $8863cd8fe199f948$var$runUpdates(()=>{
            $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = true);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
            $8863cd8fe199f948$var$runComputation(node, node.tValue, time);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        }, false);
    });
    $8863cd8fe199f948$var$Listener = listener;
    $8863cd8fe199f948$var$Owner = owner;
}
function $8863cd8fe199f948$var$runComputation(node, value, time) {
    let nextValue;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
                node.tState = $8863cd8fe199f948$var$STALE;
                node.tOwned && node.tOwned.forEach($8863cd8fe199f948$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $8863cd8fe199f948$var$STALE;
                node.owned && node.owned.forEach($8863cd8fe199f948$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $8863cd8fe199f948$var$handleError(err);
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $8863cd8fe199f948$var$writeSignal(node, nextValue, true);
        else if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) {
            $8863cd8fe199f948$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $8863cd8fe199f948$var$createComputation(fn, init, pure, state = $8863cd8fe199f948$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $8863cd8fe199f948$var$Owner,
        context: $8863cd8fe199f948$var$Owner ? $8863cd8fe199f948$var$Owner.context : null,
        pure: pure
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner !== $8863cd8fe199f948$var$UNOWNED) {
        if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Owner.pure) {
            if (!$8863cd8fe199f948$var$Owner.tOwned) $8863cd8fe199f948$var$Owner.tOwned = [
                c
            ];
            else $8863cd8fe199f948$var$Owner.tOwned.push(c);
        } else if (!$8863cd8fe199f948$var$Owner.owned) $8863cd8fe199f948$var$Owner.owned = [
            c
        ];
        else $8863cd8fe199f948$var$Owner.owned.push(c);
    }
    if ($8863cd8fe199f948$var$ExternalSourceFactory) {
        const [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $8863cd8fe199f948$var$ExternalSourceFactory(c.fn, trigger);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        const triggerInTransition = ()=>$8863cd8fe199f948$export$7568632d0d33d16d(trigger).then(()=>inTransition.dispose());
        const inTransition = $8863cd8fe199f948$var$ExternalSourceFactory(c.fn, triggerInTransition);
        c.fn = (x)=>{
            track();
            return $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running ? inTransition.track(x) : ordinary.track(x);
        };
    }
    return c;
}
function $8863cd8fe199f948$var$runTop(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) return $8863cd8fe199f948$var$lookUpstream(node);
    if (node.suspense && $8863cd8fe199f948$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $8863cd8fe199f948$var$ExecCount)){
        if (runningTransition && $8863cd8fe199f948$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($8863cd8fe199f948$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(node, ancestors[0]), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
}
function $8863cd8fe199f948$var$runUpdates(fn, init) {
    if ($8863cd8fe199f948$var$Updates) return fn();
    let wait = false;
    if (!init) $8863cd8fe199f948$var$Updates = [];
    if ($8863cd8fe199f948$var$Effects) wait = true;
    else $8863cd8fe199f948$var$Effects = [];
    $8863cd8fe199f948$var$ExecCount++;
    try {
        const res = fn();
        $8863cd8fe199f948$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $8863cd8fe199f948$var$Effects = null;
        $8863cd8fe199f948$var$Updates = null;
        $8863cd8fe199f948$var$handleError(err);
    }
}
function $8863cd8fe199f948$var$completeUpdates(wait) {
    if ($8863cd8fe199f948$var$Updates) {
        if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$scheduleQueue($8863cd8fe199f948$var$Updates);
        else $8863cd8fe199f948$var$runQueue($8863cd8fe199f948$var$Updates);
        $8863cd8fe199f948$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($8863cd8fe199f948$var$Transition) {
        if (!$8863cd8fe199f948$var$Transition.promises.size && !$8863cd8fe199f948$var$Transition.queue.size) {
            const sources = $8863cd8fe199f948$var$Transition.sources;
            const disposed = $8863cd8fe199f948$var$Transition.disposed;
            $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, $8863cd8fe199f948$var$Transition.effects);
            res = $8863cd8fe199f948$var$Transition.resolve;
            for (const e of $8863cd8fe199f948$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $8863cd8fe199f948$var$Transition = null;
            $8863cd8fe199f948$var$runUpdates(()=>{
                for (const d of disposed)$8863cd8fe199f948$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$8863cd8fe199f948$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $8863cd8fe199f948$var$setTransPending(false);
            }, false);
        } else if ($8863cd8fe199f948$var$Transition.running) {
            $8863cd8fe199f948$var$Transition.running = false;
            $8863cd8fe199f948$var$Transition.effects.push.apply($8863cd8fe199f948$var$Transition.effects, $8863cd8fe199f948$var$Effects);
            $8863cd8fe199f948$var$Effects = null;
            $8863cd8fe199f948$var$setTransPending(true);
            return;
        }
    }
    const e = $8863cd8fe199f948$var$Effects;
    $8863cd8fe199f948$var$Effects = null;
    if (e.length) $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$runEffects(e), false);
    if (res) res();
}
function $8863cd8fe199f948$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $8863cd8fe199f948$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $8863cd8fe199f948$var$Scheduler(()=>{
                tasks.delete(item);
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    $8863cd8fe199f948$var$runTop(item);
                }, false);
                $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = false);
            });
        }
    }
}
function $8863cd8fe199f948$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $8863cd8fe199f948$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.count) {
            $8863cd8fe199f948$export$2cb4986bed338027.effects || ($8863cd8fe199f948$export$2cb4986bed338027.effects = []);
            $8863cd8fe199f948$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        } else if ($8863cd8fe199f948$export$2cb4986bed338027.effects) {
            queue = [
                ...$8863cd8fe199f948$export$2cb4986bed338027.effects,
                ...queue
            ];
            userLength += $8863cd8fe199f948$export$2cb4986bed338027.effects.length;
            delete $8863cd8fe199f948$export$2cb4986bed338027.effects;
        }
        $8863cd8fe199f948$var$setHydrateContext();
    }
    for(i = 0; i < userLength; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$lookUpstream(node, ignore) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $8863cd8fe199f948$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $8863cd8fe199f948$var$ExecCount)) $8863cd8fe199f948$var$runTop(source);
            } else if (state === $8863cd8fe199f948$var$PENDING) $8863cd8fe199f948$var$lookUpstream(source, ignore);
        }
    }
}
function $8863cd8fe199f948$var$markDownstream(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $8863cd8fe199f948$var$PENDING;
            else o.state = $8863cd8fe199f948$var$PENDING;
            if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
            else $8863cd8fe199f948$var$Effects.push(o);
            o.observers && $8863cd8fe199f948$var$markDownstream(o);
        }
    }
}
function $8863cd8fe199f948$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) {
        if (node.tOwned) {
            for(i = node.tOwned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.tOwned[i]);
            delete node.tOwned;
        }
        $8863cd8fe199f948$var$reset(node, true);
    } else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $8863cd8fe199f948$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $8863cd8fe199f948$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$8863cd8fe199f948$var$reset(node.owned[i]);
}
function $8863cd8fe199f948$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $8863cd8fe199f948$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $8863cd8fe199f948$var$handleError(e, owner && owner.owner || null);
    }
}
function $8863cd8fe199f948$var$handleError(err, owner = $8863cd8fe199f948$var$Owner) {
    const fns = $8863cd8fe199f948$var$ERROR && owner && owner.context && owner.context[$8863cd8fe199f948$var$ERROR];
    const error = $8863cd8fe199f948$var$castError(err);
    if (!fns) throw error;
    if ($8863cd8fe199f948$var$Effects) $8863cd8fe199f948$var$Effects.push({
        fn () {
            $8863cd8fe199f948$var$runErrors(error, fns, owner);
        },
        state: $8863cd8fe199f948$var$STALE
    });
    else $8863cd8fe199f948$var$runErrors(error, fns, owner);
}
function $8863cd8fe199f948$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $8863cd8fe199f948$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $8863cd8fe199f948$var$resolveChildren(children[i]);
            Array.isArray(result) ? results.push.apply(results, result) : results.push(result);
        }
        return results;
    }
    return children;
}
function $8863cd8fe199f948$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $8863cd8fe199f948$export$314dade334ae905d(()=>res = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                $8863cd8fe199f948$var$Owner.context = {
                    ...$8863cd8fe199f948$var$Owner.context,
                    [id]: props.value
                };
                return $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $8863cd8fe199f948$export$2288787135a8f66e(fn) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.context === null || !$8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR]) {
        $8863cd8fe199f948$var$Owner.context = {
            ...$8863cd8fe199f948$var$Owner.context,
            [$8863cd8fe199f948$var$ERROR]: [
                fn
            ]
        };
        $8863cd8fe199f948$var$mutateContext($8863cd8fe199f948$var$Owner, $8863cd8fe199f948$var$ERROR, [
            fn
        ]);
    } else $8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR].push(fn);
}
function $8863cd8fe199f948$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $8863cd8fe199f948$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                $8863cd8fe199f948$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $8863cd8fe199f948$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($8863cd8fe199f948$export$5f4ed0d56c2c0edf()) $8863cd8fe199f948$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $8863cd8fe199f948$export$6788812c4e6611e6(producer) {
    const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $8863cd8fe199f948$var$FALLBACK = Symbol("fallback");
function $8863cd8fe199f948$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $8863cd8fe199f948$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], i, j;
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            let newLen = newItems.length, newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $8863cd8fe199f948$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [];
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            if (newItems.length === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $8863cd8fe199f948$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newItems.length; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newItems.length;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $8863cd8fe199f948$var$hydrationEnabled = false;
function $8863cd8fe199f948$export$849801d35d2160c9() {
    $8863cd8fe199f948$var$hydrationEnabled = true;
}
function $8863cd8fe199f948$export$60e54eaca7e7fb38(Comp, props) {
    if ($8863cd8fe199f948$var$hydrationEnabled) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
            const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
            $8863cd8fe199f948$var$setHydrateContext($8863cd8fe199f948$var$nextHydrateContext());
            const r = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $8863cd8fe199f948$var$setHydrateContext(c);
            return r;
        }
    }
    return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $8863cd8fe199f948$var$trueFn() {
    return true;
}
const $8863cd8fe199f948$var$propTraps = {
    get (_, property, receiver) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $8863cd8fe199f948$var$trueFn,
    deleteProperty: $8863cd8fe199f948$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $8863cd8fe199f948$var$trueFn,
            deleteProperty: $8863cd8fe199f948$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $8863cd8fe199f948$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $8863cd8fe199f948$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $8863cd8fe199f948$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $8863cd8fe199f948$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if (proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $8863cd8fe199f948$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $8863cd8fe199f948$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($8863cd8fe199f948$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $8863cd8fe199f948$var$propTraps);
    const target = {};
    const sourcesMap = {};
    const defined = new Set();
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = 0, length = sourceKeys.length; i < length; i++){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined.has(key)) {
                if (desc.get) {
                    defined.add(key);
                    Object.defineProperty(target, key, {
                        enumerable: true,
                        configurable: true,
                        get: $8863cd8fe199f948$var$resolveSources.bind(sourcesMap[key] = [
                            desc.get.bind(source)
                        ])
                    });
                } else {
                    if (desc.value !== undefined) defined.add(key);
                    target[key] = desc.value;
                }
            } else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                } else if (target[key] === undefined) target[key] = desc.value;
            }
        }
    }
    return target;
}
function $8863cd8fe199f948$export$45029c61b0073d87(props, ...keys) {
    if ($8863cd8fe199f948$export$5cd89106e2f6c2c5 in props) {
        const blocked = new Set(keys.length > 1 ? keys.flat() : keys[0]);
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, $8863cd8fe199f948$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.has(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.has(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.has(k));
            }
        }, $8863cd8fe199f948$var$propTraps));
        return res;
    }
    const otherObject = {};
    const objects = keys.map(()=>({}));
    for (const propName of Object.getOwnPropertyNames(props)){
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        let blocked = false;
        let objectIndex = 0;
        for (const k of keys){
            if (k.includes(propName)) {
                blocked = true;
                isDefaultDesc ? objects[objectIndex][propName] = desc.value : Object.defineProperty(objects[objectIndex], propName, desc);
            }
            ++objectIndex;
        }
        if (!blocked) isDefaultDesc ? otherObject[propName] = desc.value : Object.defineProperty(otherObject, propName, desc);
    }
    return [
        ...objects,
        otherObject
    ];
}
function $8863cd8fe199f948$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5();
            $8863cd8fe199f948$export$2cb4986bed338027.count || ($8863cd8fe199f948$export$2cb4986bed338027.count = 0);
            $8863cd8fe199f948$export$2cb4986bed338027.count++;
            (p || (p = fn())).then((mod)=>{
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                $8863cd8fe199f948$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $8863cd8fe199f948$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $8863cd8fe199f948$export$edd172c6c83c39cc(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>(Comp = comp()) && $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                if (!ctx) return Comp(props);
                const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                const r = Comp(props);
                $8863cd8fe199f948$var$setHydrateContext(c);
                return r;
            }));
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let $8863cd8fe199f948$var$counter = 0;
function $8863cd8fe199f948$export$33208d63bc845a83() {
    const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
    return ctx ? `${ctx.id}${ctx.count++}` : `cl-${$8863cd8fe199f948$var$counter++}`;
}
const $8863cd8fe199f948$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $8863cd8fe199f948$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const condition = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, {
        equals: (a, b)=>keyed ? a === b : !a === !b
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$8863cd8fe199f948$export$363ebc4b78b8f807(condition)) throw $8863cd8fe199f948$var$narrowedError("Show");
                    return props.when;
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$b5d5cf8927ab7262(props) {
    let keyed = false;
    const equals = (a, b)=>a[0] === b[0] && (keyed ? a[1] === b[1] : !a[1] === !b[1]) && a[2] === b[2];
    const conditions = $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children), evalConditions = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        let conds = conditions();
        if (!Array.isArray(conds)) conds = [
            conds
        ];
        for(let i = 0; i < conds.length; i++){
            const c = conds[i].when;
            if (c) {
                keyed = !!conds[i].keyed;
                return [
                    i,
                    c,
                    conds[i]
                ];
            }
        }
        return [
            -1
        ];
    }, undefined, {
        equals: equals
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const [index, when, cond] = evalConditions();
        if (index < 0) return props.fallback;
        const c = cond.children;
        const fn = typeof c === "function" && c.length > 0;
        return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>c(keyed ? when : ()=>{
                if ($8863cd8fe199f948$export$363ebc4b78b8f807(evalConditions)[0] !== index) throw $8863cd8fe199f948$var$narrowedError("Match");
                return cond.when;
            })) : c;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$f421feb8fad20413(props) {
    return props;
}
let $8863cd8fe199f948$var$Errors;
function $8863cd8fe199f948$export$4eaee74ee7a14dca() {
    $8863cd8fe199f948$var$Errors && [
        ...$8863cd8fe199f948$var$Errors
    ].forEach((fn)=>fn());
}
function $8863cd8fe199f948$export$e926676385687eaf(props) {
    let err;
    let v;
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load && (v = $8863cd8fe199f948$export$2cb4986bed338027.load($8863cd8fe199f948$export$2cb4986bed338027.context.id + $8863cd8fe199f948$export$2cb4986bed338027.context.count))) err = v[0];
    const [errored, setErrored] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(err, undefined);
    $8863cd8fe199f948$var$Errors || ($8863cd8fe199f948$var$Errors = new Set());
    $8863cd8fe199f948$var$Errors.add(setErrored);
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$Errors.delete(setErrored));
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $8863cd8fe199f948$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $8863cd8fe199f948$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $8863cd8fe199f948$var$SuspenseListContext = $8863cd8fe199f948$export$fd42f52fd3ae1109();
function $8863cd8fe199f948$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    const [registry, setRegistry] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $8863cd8fe199f948$export$60e54eaca7e7fb38($8863cd8fe199f948$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $8863cd8fe199f948$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $8863cd8fe199f948$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false), SuspenseContext = $8863cd8fe199f948$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $8863cd8fe199f948$export$5f4ed0d56c2c0edf();
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load) {
        const key = $8863cd8fe199f948$export$2cb4986bed338027.context.id + $8863cd8fe199f948$export$2cb4986bed338027.context.count;
        let ref = $8863cd8fe199f948$export$2cb4986bed338027.load(key);
        if (ref && (p = ref[0]) && p !== "$$f") {
            if (typeof p !== "object" || !("then" in p)) p = Promise.resolve(p);
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then((err)=>{
                if (err || $8863cd8fe199f948$export$2cb4986bed338027.done) {
                    err && (error = err);
                    return set();
                }
                $8863cd8fe199f948$export$2cb4986bed338027.gather(key);
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                set();
                $8863cd8fe199f948$var$setHydrateContext();
            });
        }
    }
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $8863cd8fe199f948$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $8863cd8fe199f948$var$setHydrateContext();
                const rendered = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $8863cd8fe199f948$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $8863cd8fe199f948$var$setHydrateContext({
                                id: ctx.id + "f",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $8863cd8fe199f948$export$404582bc18fe4d9e = undefined;


const $6258376c5c54faa9$var$booleans = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
];
const $6258376c5c54faa9$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    ...$6258376c5c54faa9$var$booleans
]);
const $6258376c5c54faa9$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $6258376c5c54faa9$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $6258376c5c54faa9$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
function $6258376c5c54faa9$export$72dcdd3761a309a9(prop, tagName) {
    const a = $6258376c5c54faa9$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $6258376c5c54faa9$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $6258376c5c54faa9$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $6258376c5c54faa9$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $6258376c5c54faa9$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
function $6258376c5c54faa9$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $6258376c5c54faa9$var$$$EVENTS = "_$DX_DELEGATE";
function $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $6258376c5c54faa9$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $6258376c5c54faa9$export$ce69bd05624d0c48(html, isCE, isSVG) {
    let node;
    const create = ()=>{
        const t = document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : t.content.firstChild;
    };
    const fn = isCE ? ()=>(0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $6258376c5c54faa9$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$6258376c5c54faa9$var$$$EVENTS] || (document1[$6258376c5c54faa9$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $6258376c5c54faa9$var$eventHandler);
        }
    }
}
function $6258376c5c54faa9$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$6258376c5c54faa9$var$$$EVENTS]) {
        for (let name of document1[$6258376c5c54faa9$var$$$EVENTS].keys())document1.removeEventListener(name, $6258376c5c54faa9$var$eventHandler);
        delete document1[$6258376c5c54faa9$var$$$EVENTS];
    }
}
function $6258376c5c54faa9$export$9fec4d97f1922e0b(node, name, value) {
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $6258376c5c54faa9$export$75900142c9e21800(node, namespace, name, value) {
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $6258376c5c54faa9$export$2913c0c0b5623090(node, value) {
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler);
}
function $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $6258376c5c54faa9$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $6258376c5c54faa9$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>prevProps.children = $6258376c5c54faa9$var$insertExpression(node, props.children, prevProps.children));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>props.ref && props.ref(node));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>$6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $6258376c5c54faa9$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $6258376c5c54faa9$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $8863cd8fe199f948$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $6258376c5c54faa9$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $6258376c5c54faa9$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $6258376c5c54faa9$var$insertExpression(parent, accessor, initial, marker);
    (0, $8863cd8fe199f948$export$314dade334ae905d)((current)=>$6258376c5c54faa9$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $6258376c5c54faa9$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef);
    }
}
function $6258376c5c54faa9$var$hydrate$1(code, element, options = {}) {
    (0, $8863cd8fe199f948$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).load = globalThis._$HY.load;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).gather = (root)=>$6258376c5c54faa9$var$gatherHydratable(element, root);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry = new Map();
    (0, $8863cd8fe199f948$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    $6258376c5c54faa9$var$gatherHydratable(element, options.renderId);
    const dispose = $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).context = null;
    return dispose;
}
function $6258376c5c54faa9$export$4109ed81edd7716d(template) {
    let node, key;
    if (!(0, $8863cd8fe199f948$export$2cb4986bed338027).context || !(node = (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.get(key = $6258376c5c54faa9$export$a5a9dff0691837de()))) {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) console.warn("Unable to find DOM nodes for hydration key:", key);
        if (!template) throw new Error("Unrecoverable Hydration Mismatch. No template for key: " + key);
        return template();
    }
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).completed) (0, $8863cd8fe199f948$export$2cb4986bed338027).completed.add(node);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $6258376c5c54faa9$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $6258376c5c54faa9$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "#") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $6258376c5c54faa9$export$6fef5763b6d3688d() {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).events && !(0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $8863cd8fe199f948$export$2cb4986bed338027);
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                $6258376c5c54faa9$var$eventHandler(e);
                events.shift();
            }
        });
        (0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued = true;
    }
}
function $6258376c5c54faa9$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $6258376c5c54faa9$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $6258376c5c54faa9$var$assignProp(node, prop, value, prev, isSVG, skipRef) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev);
        value && node.addEventListener(e, value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $6258376c5c54faa9$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $6258376c5c54faa9$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $6258376c5c54faa9$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $6258376c5c54faa9$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $6258376c5c54faa9$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $6258376c5c54faa9$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-"))) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        }
        if (prop === "class" || prop === "className") $6258376c5c54faa9$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$6258376c5c54faa9$var$toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $6258376c5c54faa9$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $6258376c5c54faa9$export$75900142c9e21800(node, ns, prop, value);
        else $6258376c5c54faa9$export$9fec4d97f1922e0b(node, $6258376c5c54faa9$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $6258376c5c54faa9$var$eventHandler(e) {
    const key = `$$${e.type}`;
    let node = e.composedPath && e.composedPath()[0] || e.target;
    if (e.target !== node) Object.defineProperty(e, "target", {
        configurable: true,
        value: node
    });
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done) (0, $8863cd8fe199f948$export$2cb4986bed338027).done = _$HY.done = true;
    while(node){
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node = node._$host || node.parentNode || node.host;
    }
}
function $6258376c5c54faa9$var$insertExpression(parent, value, current, marker, unwrapArray) {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) return current;
        if (t === "number") value = value.toString();
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data = value;
            else node = document.createTextNode(value);
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) return current;
        current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $6258376c5c54faa9$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($6258376c5c54faa9$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>current = $6258376c5c54faa9$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context) {
            if (!array.length) return current;
            for(let i = 0; i < array.length; i++){
                if (array[i].parentNode) return current = array;
            }
        }
        if (array.length === 0) {
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $6258376c5c54faa9$var$appendNodes(parent, array, marker);
            else $6258376c5c54faa9$var$reconcileArrays(parent, current, array);
        } else {
            current && $6258376c5c54faa9$var$cleanChildren(parent);
            $6258376c5c54faa9$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).context && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, value);
            $6258376c5c54faa9$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    } else console.warn(`Unrecognized value. Skipped inserting`, value);
    return current;
}
function $6258376c5c54faa9$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[i], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $6258376c5c54faa9$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $6258376c5c54faa9$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $6258376c5c54faa9$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $8863cd8fe199f948$export$2cb4986bed338027).registry.has(key)) (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $6258376c5c54faa9$export$a5a9dff0691837de() {
    const hydrate = (0, $8863cd8fe199f948$export$2cb4986bed338027).context;
    return `${hydrate.id}${hydrate.count++}`;
}
function $6258376c5c54faa9$export$36143b7c9c07dd39(props) {
    return (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? undefined : props.children;
}
function $6258376c5c54faa9$export$da8cca6e5dfa3577(props) {
    return props.children;
}
function $6258376c5c54faa9$export$c8eca95e306f7116() {}
function $6258376c5c54faa9$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $6258376c5c54faa9$export$80e7718417253a51(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$80e7718417253a51);
}
function $6258376c5c54faa9$export$f3aefc4196cd5f3e(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$f3aefc4196cd5f3e);
}
function $6258376c5c54faa9$export$97f86213fef5749d(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$97f86213fef5749d);
}
function $6258376c5c54faa9$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $6258376c5c54faa9$export$1844beb7faeb4553(name, props, children, needsId) {}
function $6258376c5c54faa9$export$e92e0c287593a882(value) {}
function $6258376c5c54faa9$export$9e97f11b9d683d7a(value) {}
function $6258376c5c54faa9$export$9ab8bdc1e27e51e1(key, value) {}
function $6258376c5c54faa9$export$7e66a08c0b8ab2aa() {}
function $6258376c5c54faa9$export$755e9f954b4fd36e(node) {}
function $6258376c5c54faa9$export$4e7f196112fea3c5(html) {}
function $6258376c5c54faa9$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $6258376c5c54faa9$export$6acf61af03e62db = false;
const $6258376c5c54faa9$export$40edfb7eeb78c4e8 = false;
const $6258376c5c54faa9$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $6258376c5c54faa9$var$createElement(tagName, isSVG = false) {
    return isSVG ? document.createElementNS($6258376c5c54faa9$var$SVG_NAMESPACE, tagName) : document.createElement(tagName);
}
const $6258376c5c54faa9$export$fa8d919ba61d84db = (...args)=>{
    (0, $8863cd8fe199f948$export$849801d35d2160c9)();
    return $6258376c5c54faa9$var$hydrate$1(...args);
};
function $6258376c5c54faa9$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $8863cd8fe199f948$export$2cb4986bed338027).context;
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $8863cd8fe199f948$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>$6258376c5c54faa9$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $6258376c5c54faa9$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $6258376c5c54faa9$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $6258376c5c54faa9$export$e18282e419e46834(props) {
    const [p, others] = (0, $8863cd8fe199f948$export$45029c61b0073d87)(props, [
        "component"
    ]);
    const cached = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>p.component);
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                Object.assign(component, {
                    [(0, $8863cd8fe199f948$export$f5625ae0b78e5b20)]: true
                });
                return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>component(others));
            case "string":
                const isSvg = $6258376c5c54faa9$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? $6258376c5c54faa9$export$4109ed81edd7716d() : $6258376c5c54faa9$var$createElement(component, isSvg);
                $6258376c5c54faa9$export$3ae0fd4797ed47c8(el, others, isSvg);
                return el;
        }
    });
}






const $b0a42ae73c325226$export$1b1fb4c7e01569c9 = "https://git.unistra.fr";
const $b0a42ae73c325226$export$990e650689f41099 = "https://{namespace}.pages.unistra.fr/{name}";
const $b0a42ae73c325226$export$de0b4ca3ce20da95 = ({ name: name, namespace: namespace })=>{
    return $b0a42ae73c325226$export$990e650689f41099.replace("{namespace}", namespace.name).replace("{name}", name);
};


const $0ab46d09fa7ca2c2$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="spinner-border" role="status">Loading...`), $0ab46d09fa7ca2c2$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning" role="alert">Le projet n'a pas encore été créé <button type="button" class="btn btn-primary">`), $0ab46d09fa7ca2c2$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning" role="alert">L'utilisateur gitlab nommé <b></b> n'existe pas, créez un compte sur <a target="_blank" class="alert-link"></a> puis recommencez.`), $0ab46d09fa7ca2c2$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card" style="width:18rem;"><div class="card-body"><h5 class="card-title">Projet <a> </a></h5><h6 class="card-subtitle mb-2 text-muted">id: </h6><a class="card-link">Repository</a><a class="card-link">Pages`), $0ab46d09fa7ca2c2$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $0ab46d09fa7ca2c2$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger" role="alert">Erreur Inconnue, recommencez ou contactez l'administrateur.<br>(<!>)`);
const $0ab46d09fa7ca2c2$var$Loader = ()=>$0ab46d09fa7ca2c2$var$_tmpl$();
const $0ab46d09fa7ca2c2$export$a64da8fc8b9c1af9 = (props)=>{
    console.log("projectView", props.state().project);
    /*
      if(props.state().project.error) {
        switch(props.state().project.error){
          
          case 'NO_PROJECT':
            return <div class="alert alert-warning" role="alert">
              Le projet n'a pas encore été créé <button
              disabled={props.state().creatingProject}
              type="button"
              class="btn btn-primary"
              onClick={[props.createProject, null]}>
                {props.state().creatingProject ? ' Création du Projet' : 'Créer le projet'}
              </button>
            </div>
          case 'NO_GITLAB_USER':
            return <div class="alert alert-warning" role="alert">
              L'utilisateur gitlab nommé <b>{props.state().username}</b> n'existe pas,
              créez un compte sur <a href={config.GITLAB_URL}
              target='_blank'
              class="alert-link">{config.GITLAB_URL}</a> puis recommencez.
            </div>
          default:
          case 'UNKNOWN':
            return <div class="alert alert-danger" role="alert">
              Erreur Inconnue, recommencez ou contactez l'administrateur.
            </div>
        }
      }*/ return (()=>{
        const _el$2 = $0ab46d09fa7ca2c2$var$_tmpl$5();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.state().project;
            },
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return props.state().project.error;
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$b5d5cf8927ab7262), {
                                get fallback () {
                                    return (()=>{
                                        const _el$21 = $0ab46d09fa7ca2c2$var$_tmpl$6(), _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling, _el$24 = _el$23.nextSibling, _el$26 = _el$24.nextSibling, _el$25 = _el$26.nextSibling;
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>props.state().project.message, _el$26);
                                        return _el$21;
                                    })();
                                },
                                get children () {
                                    return [
                                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                                            get when () {
                                                return props.state().project.error === "NO_PROJECT";
                                            },
                                            get children () {
                                                const _el$3 = $0ab46d09fa7ca2c2$var$_tmpl$2(), _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling;
                                                _el$5.$$click = props.createProject;
                                                _el$5.$$clickData = null;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>props.state().creatingProject ? " Cr\xe9ation du Projet" : "Cr\xe9er le projet");
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$5.disabled = props.state().creatingProject);
                                                return _el$3;
                                            }
                                        }),
                                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                                            get when () {
                                                return props.state().project.error === "NO_GITLAB_USER";
                                            },
                                            get children () {
                                                const _el$6 = $0ab46d09fa7ca2c2$var$_tmpl$3(), _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$10 = _el$9.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>props.state().username);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>$b0a42ae73c325226$export$1b1fb4c7e01569c9);
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$10, "href", $b0a42ae73c325226$export$1b1fb4c7e01569c9));
                                                return _el$6;
                                            }
                                        })
                                    ];
                                }
                            });
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return !props.state().project.error;
                        },
                        get children () {
                            const _el$11 = $0ab46d09fa7ca2c2$var$_tmpl$4(), _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.firstChild, _el$15 = _el$14.nextSibling, _el$16 = _el$15.firstChild, _el$17 = _el$13.nextSibling, _el$18 = _el$17.firstChild, _el$19 = _el$17.nextSibling, _el$20 = _el$19.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>props.state().project.url, null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>props.state().project.id, null);
                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                const _v$ = props.state().project.url, _v$2 = props.state().project.url, _v$3 = $b0a42ae73c325226$export$de0b4ca3ce20da95(props.state().project);
                                _v$ !== _p$._v$ && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$15, "href", _p$._v$ = _v$);
                                _v$2 !== _p$._v$2 && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$19, "href", _p$._v$2 = _v$2);
                                _v$3 !== _p$._v$3 && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$20, "href", _p$._v$3 = _v$3);
                                return _p$;
                            }, {
                                _v$: undefined,
                                _v$2: undefined,
                                _v$3: undefined
                            });
                            return _el$11;
                        }
                    })
                ];
            }
        }));
        return _el$2;
    })();
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);





const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $b417fd17fc84e4e3$export$c169aefb7330cccb)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type];
    if (!packetType) return 0, $b417fd17fc84e4e3$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $7f4e842ae29bcbc5$export$2f872c0f2117be69)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $a9bf3da28855a34f$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $8a3662315a48cdbd$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $a9bf3da28855a34f$export$4647901878f33f31)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $8ff0082eecb39b62$export$4293555f241ae35a(obj) {
    if (obj) return $8ff0082eecb39b62$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $8ff0082eecb39b62$var$mixin(obj) {
    for(var key in $8ff0082eecb39b62$export$4293555f241ae35a.prototype)obj[key] = $8ff0082eecb39b62$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.on = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.off = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeListener = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeAllListeners = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$8ff0082eecb39b62$export$4293555f241ae35a.prototype.emitReserved = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $26bf9c4279db2ef0$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();


function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $26bf9c4279db2ef0$export$394f9358f6231289).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $26bf9c4279db2ef0$export$394f9358f6231289).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $26bf9c4279db2ef0$export$394f9358f6231289));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $26bf9c4279db2ef0$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $26bf9c4279db2ef0$export$394f9358f6231289).setTimeout.bind((0, $26bf9c4279db2ef0$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $26bf9c4279db2ef0$export$394f9358f6231289).clearTimeout.bind((0, $26bf9c4279db2ef0$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $4a78f487f5bb98d8$var$TransportError extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$var$TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $a9bf3da28855a34f$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $19744bce3c183d10$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}


// imported from https://github.com/unshiftio/yeast
"use strict";
const $a3bbf5b17719daf1$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $a3bbf5b17719daf1$var$length = 64, $a3bbf5b17719daf1$var$map = {};
let $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$i = 0, $a3bbf5b17719daf1$var$prev;
function $a3bbf5b17719daf1$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $a3bbf5b17719daf1$var$alphabet[num % $a3bbf5b17719daf1$var$length] + encoded;
        num = Math.floor(num / $a3bbf5b17719daf1$var$length);
    }while (num > 0);
    return encoded;
}
function $a3bbf5b17719daf1$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($a3bbf5b17719daf1$var$i = 0; $a3bbf5b17719daf1$var$i < str.length; $a3bbf5b17719daf1$var$i++)decoded = decoded * $a3bbf5b17719daf1$var$length + $a3bbf5b17719daf1$var$map[str.charAt($a3bbf5b17719daf1$var$i)];
    return decoded;
}
function $a3bbf5b17719daf1$export$5bb64b92cb4135a() {
    const now = $a3bbf5b17719daf1$export$c564cdbbe6da493(+new Date());
    if (now !== $a3bbf5b17719daf1$var$prev) return $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$prev = now;
    return now + "." + $a3bbf5b17719daf1$export$c564cdbbe6da493($a3bbf5b17719daf1$var$seed++);
}
//
// Map each character to its index.
//
for(; $a3bbf5b17719daf1$var$i < $a3bbf5b17719daf1$var$length; $a3bbf5b17719daf1$var$i++)$a3bbf5b17719daf1$var$map[$a3bbf5b17719daf1$var$alphabet[$a3bbf5b17719daf1$var$i]] = $a3bbf5b17719daf1$var$i;



// browser shim for xmlhttprequest module
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;



function $fb8e645f3bad3d56$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $ef3f42a25dd224af$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $26bf9c4279db2ef0$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $fb8e645f3bad3d56$export$19413efcf2fac759() {}





function $56534be56e5aa809$var$empty() {}
const $56534be56e5aa809$var$hasXHR2 = function() {
    const xhr = new (0, $fb8e645f3bad3d56$export$a2d42eb087c10497)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $56534be56e5aa809$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $fb8e645f3bad3d56$export$19413efcf2fac759)();
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $0736208648dc8bae$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $0736208648dc8bae$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a3bbf5b17719daf1$export$5bb64b92cb4135a)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $56534be56e5aa809$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $56534be56e5aa809$export$7fa6c5b6f8193917 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $fb8e645f3bad3d56$export$a2d42eb087c10497)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount++;
            $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $56534be56e5aa809$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
$56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount = 0;
$56534be56e5aa809$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $56534be56e5aa809$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $26bf9c4279db2ef0$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $56534be56e5aa809$var$unloadHandler, false);
    }
}
function $56534be56e5aa809$var$unloadHandler() {
    for(let i in $56534be56e5aa809$export$7fa6c5b6f8193917.requests)if ($56534be56e5aa809$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $56534be56e5aa809$export$7fa6c5b6f8193917.requests[i].abort();
}






const $93862213c34af1ff$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $93862213c34af1ff$export$3909fb301d3dc8c9 = (0, $26bf9c4279db2ef0$export$394f9358f6231289).WebSocket || (0, $26bf9c4279db2ef0$export$394f9358f6231289).MozWebSocket;
const $93862213c34af1ff$export$3407ba5dfb7a683d = true;
const $93862213c34af1ff$export$790dcbc41e2d75d5 = "arraybuffer";



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $9ab7b46a38551fa4$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$911baa0677ac404c extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $93862213c34af1ff$export$3407ba5dfb7a683d) && !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new (0, $93862213c34af1ff$export$3909fb301d3dc8c9)(uri, protocols) : new (0, $93862213c34af1ff$export$3909fb301d3dc8c9)(uri) : new (0, $93862213c34af1ff$export$3909fb301d3dc8c9)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $93862213c34af1ff$export$3407ba5dfb7a683d)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $9ab7b46a38551fa4$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $93862213c34af1ff$export$3407ba5dfb7a683d) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $93862213c34af1ff$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a3bbf5b17719daf1$export$5bb64b92cb4135a)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $93862213c34af1ff$export$3909fb301d3dc8c9);
    }
}





class $cea1ad415a07b478$export$961c930859384407 extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $0736208648dc8bae$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $0736208648dc8bae$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $93862213c34af1ff$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}


const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $9ab7b46a38551fa4$export$911baa0677ac404c),
    webtransport: (0, $cea1ad415a07b478$export$961c930859384407),
    polling: (0, $56534be56e5aa809$export$265ee5eefd4c309b)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri["path"]);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri["query"]);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





class $787375aed2c43820$export$4798917dbf149b79 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $93862213c34af1ff$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(opts.host).host;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $19744bce3c183d10$export$2f872c0f2117be69)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $c1f726e793763466$export$46dec00755c1153b)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $4028d5a20a4526d1$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$787375aed2c43820$export$4798917dbf149b79.protocol = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);







const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $787375aed2c43820$export$4798917dbf149b79).protocol;


function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $1e4e6e6cc3958162$exports = {};

$parcel$export($1e4e6e6cc3958162$exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export($1e4e6e6cc3958162$exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export($1e4e6e6cc3958162$exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export($1e4e6e6cc3958162$exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $ab192732c3780e48$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $ab192732c3780e48$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $67dd224d5a131c9e$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $ab192732c3780e48$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $67dd224d5a131c9e$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $05fb321879039179$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $8ff0082eecb39b62$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3f0f0eae169725b6$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $1e4e6e6cc3958162$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $787375aed2c43820$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $05fb321879039179$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $05fb321879039179$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $93862213c34af1ff$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $fcab49da21a6222a$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}




/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $efe27346e00da8a8$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $b78f1c3cb524f77d$export$d0d38e7dec7a1a61,
    Socket: $fcab49da21a6222a$export$4798917dbf149b79,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});



const $a26018a1d2174fbf$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="socket-status"><div class="alert alert-danger" role="alert"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>Connexion au serveur perdue...`);
const $a26018a1d2174fbf$var$socket = (0, $523eaa49d3f99bf8$export$841407ceb083bd74)({
    transports: [
        "websocket",
        "polling"
    ] // use WebSocket first, if available
});
// retrieve query params 'jwt'
const $a26018a1d2174fbf$var$urlParams = new URLSearchParams(window.location.search);
const $a26018a1d2174fbf$var$jwt = $a26018a1d2174fbf$var$urlParams.get("jwt") || localStorage.getItem("jwt");
if ($a26018a1d2174fbf$var$jwt) localStorage.setItem("jwt", $a26018a1d2174fbf$var$jwt);
if ($a26018a1d2174fbf$var$urlParams.get("jwt")) //remove jwt from url
window.history.replaceState({}, document.title, "/");
$a26018a1d2174fbf$var$socket.on("connect", ()=>{
    console.log("connected");
    console.log({
        jwt: $a26018a1d2174fbf$var$jwt
    });
    if ($a26018a1d2174fbf$var$jwt) $a26018a1d2174fbf$var$socket.emit("authenticate", $a26018a1d2174fbf$var$jwt);
});
$a26018a1d2174fbf$var$socket.on("unauthorized", (error)=>{
    console.log({
        error: error
    });
    localStorage.removeItem("jwt");
});
var $a26018a1d2174fbf$export$2e2bcd8739ae039 = $a26018a1d2174fbf$var$socket;
const $a26018a1d2174fbf$export$d049364d16567d0d = ()=>{
    const [status, setStatus] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("disconnected");
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        $a26018a1d2174fbf$var$socket.on("connect", ()=>{
            console.log("connected");
            setStatus("connected");
        });
        $a26018a1d2174fbf$var$socket.on("disconnect", ()=>{
            setStatus("disconnected");
            console.log("disconnect");
        });
    });
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
        get when () {
            return status() == "disconnected";
        },
        get children () {
            return $a26018a1d2174fbf$var$_tmpl$();
        }
    });
};







const $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 = Symbol("store-raw"), $caa70d287a6ddb62$var$$NODE = Symbol("store-node"), $caa70d287a6ddb62$var$$HAS = Symbol("store-has"), $caa70d287a6ddb62$var$$SELF = Symbol("store-self");
function $caa70d287a6ddb62$var$wrap$1(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps$1)
        });
        if (!Array.isArray(value)) {
            const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
            for(let i = 0, l = keys.length; i < l; i++){
                const prop = keys[i];
                if (desc[prop].get) Object.defineProperty(value, prop, {
                    enumerable: desc[prop].enumerable,
                    get: desc[prop].get.bind(p)
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$var$isWrappable(obj) {
    let proto;
    return obj != null && typeof obj === "object" && (obj[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5] || !(proto = Object.getPrototypeOf(obj)) || proto === Object.prototype || Array.isArray(obj));
}
function $caa70d287a6ddb62$export$debb760848ca95a(item, set = new Set()) {
    let result, unwrapped, v, prop;
    if (result = item != null && item[$caa70d287a6ddb62$export$9f4df9bfaca7e3b7]) return result;
    if (!$caa70d287a6ddb62$var$isWrappable(item) || set.has(item)) return item;
    if (Array.isArray(item)) {
        if (Object.isFrozen(item)) item = item.slice(0);
        else set.add(item);
        for(let i = 0, l = item.length; i < l; i++){
            v = item[i];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[i] = unwrapped;
        }
    } else {
        if (Object.isFrozen(item)) item = Object.assign({}, item);
        else set.add(item);
        const keys = Object.keys(item), desc = Object.getOwnPropertyDescriptors(item);
        for(let i = 0, l = keys.length; i < l; i++){
            prop = keys[i];
            if (desc[prop].get) continue;
            v = item[prop];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[prop] = unwrapped;
        }
    }
    return item;
}
function $caa70d287a6ddb62$var$getNodes(target, symbol) {
    let nodes = target[symbol];
    if (!nodes) Object.defineProperty(target, symbol, {
        value: nodes = Object.create(null)
    });
    return nodes;
}
function $caa70d287a6ddb62$var$getNode(nodes, property, value) {
    if (nodes[property]) return nodes[property];
    const [s, set] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(value, {
        equals: false,
        internal: true
    });
    s.$ = set;
    return nodes[property] = s;
}
function $caa70d287a6ddb62$var$proxyDescriptor$1(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    return desc;
}
function $caa70d287a6ddb62$var$trackSelf(target) {
    (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE), $caa70d287a6ddb62$var$$SELF)();
}
function $caa70d287a6ddb62$var$ownKeys(target) {
    $caa70d287a6ddb62$var$trackSelf(target);
    return Reflect.ownKeys(target);
}
const $caa70d287a6ddb62$var$proxyTraps$1 = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (typeof value !== "function" || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap$1(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set () {
        return true;
    },
    deleteProperty () {
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor$1
};
function $caa70d287a6ddb62$var$setProperty(state, property, value, deleting = false) {
    if (!deleting && state[property] === value) return;
    const prev = state[property], len = state.length;
    if (value === undefined) {
        delete state[property];
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev !== undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    } else {
        state[property] = value;
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev === undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    }
    let nodes = $caa70d287a6ddb62$var$getNodes(state, $caa70d287a6ddb62$var$$NODE), node;
    if (node = $caa70d287a6ddb62$var$getNode(nodes, property, prev)) node.$(()=>value);
    if (Array.isArray(state) && state.length !== len) {
        for(let i = state.length; i < len; i++)(node = nodes[i]) && node.$();
        (node = $caa70d287a6ddb62$var$getNode(nodes, "length", len)) && node.$(state.length);
    }
    (node = nodes[$caa70d287a6ddb62$var$$SELF]) && node.$();
}
function $caa70d287a6ddb62$var$mergeStoreNode(state, value) {
    const keys = Object.keys(value);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        $caa70d287a6ddb62$var$setProperty(state, key, value[key]);
    }
}
function $caa70d287a6ddb62$var$updateArray(current, next) {
    if (typeof next === "function") next = next(current);
    next = $caa70d287a6ddb62$export$debb760848ca95a(next);
    if (Array.isArray(next)) {
        if (current === next) return;
        let i = 0, len = next.length;
        for(; i < len; i++){
            const value = next[i];
            if (current[i] !== value) $caa70d287a6ddb62$var$setProperty(current, i, value);
        }
        $caa70d287a6ddb62$var$setProperty(current, "length", len);
    } else $caa70d287a6ddb62$var$mergeStoreNode(current, next);
}
function $caa70d287a6ddb62$var$updatePath(current, path, traversed = []) {
    let part, prev = current;
    if (path.length > 1) {
        part = path.shift();
        const partType = typeof part, isArray = Array.isArray(current);
        if (Array.isArray(part)) {
            for(let i = 0; i < part.length; i++)$caa70d287a6ddb62$var$updatePath(current, [
                part[i]
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "function") {
            for(let i = 0; i < current.length; i++)if (part(current[i], i)) $caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "object") {
            const { from: from = 0, to: to = current.length - 1, by: by = 1 } = part;
            for(let i = from; i <= to; i += by)$caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (path.length > 1) {
            $caa70d287a6ddb62$var$updatePath(current[part], path, [
                part
            ].concat(traversed));
            return;
        }
        prev = current[part];
        traversed = [
            part
        ].concat(traversed);
    }
    let value = path[0];
    if (typeof value === "function") {
        value = value(prev, traversed);
        if (value === prev) return;
    }
    if (part === undefined && value == undefined) return;
    value = $caa70d287a6ddb62$export$debb760848ca95a(value);
    if (part === undefined || $caa70d287a6ddb62$var$isWrappable(prev) && $caa70d287a6ddb62$var$isWrappable(value) && !Array.isArray(value)) $caa70d287a6ddb62$var$mergeStoreNode(prev, value);
    else $caa70d287a6ddb62$var$setProperty(current, part, value);
}
function $caa70d287a6ddb62$export$f51a9068ac82ea43(...[store, options]) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(store || {});
    const isArray = Array.isArray(unwrappedStore);
    const wrappedStore = $caa70d287a6ddb62$var$wrap$1(unwrappedStore);
    function setStore(...args) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>{
            isArray && args.length === 1 ? $caa70d287a6ddb62$var$updateArray(unwrappedStore, args[0]) : $caa70d287a6ddb62$var$updatePath(unwrappedStore, args);
        });
    }
    return [
        wrappedStore,
        setStore
    ];
}
function $caa70d287a6ddb62$var$proxyDescriptor(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || desc.set || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    desc.set = (v)=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property] = v;
    return desc;
}
const $caa70d287a6ddb62$var$proxyTraps = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            const isFunction = typeof value === "function";
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (!isFunction || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
            else if (value != null && isFunction && value === Array.prototype[property]) return (...args)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>Array.prototype[property].apply(receiver, args));
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set (target, property, value) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value)));
        return true;
    },
    deleteProperty (target, property) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, undefined, true));
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor
};
function $caa70d287a6ddb62$var$wrap(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps)
        });
        const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
        for(let i = 0, l = keys.length; i < l; i++){
            const prop = keys[i];
            if (desc[prop].get) {
                const get = desc[prop].get.bind(p);
                Object.defineProperty(value, prop, {
                    get: get
                });
            }
            if (desc[prop].set) {
                const og = desc[prop].set, set = (v)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>og.call(p, v));
                Object.defineProperty(value, prop, {
                    set: set
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$export$ab7224b136d4492e(state, options) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(state || {});
    const wrappedStore = $caa70d287a6ddb62$var$wrap(unwrappedStore);
    return wrappedStore;
}
function $caa70d287a6ddb62$export$4939f032d60167b6(state, modifier) {
    (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>modifier($caa70d287a6ddb62$export$debb760848ca95a(state)));
}
const $caa70d287a6ddb62$var$$ROOT = Symbol("store-root");
function $caa70d287a6ddb62$var$applyState(target, parent, property, merge, key) {
    const previous = parent[property];
    if (target === previous) return;
    if (property !== $caa70d287a6ddb62$var$$ROOT && (!$caa70d287a6ddb62$var$isWrappable(target) || !$caa70d287a6ddb62$var$isWrappable(previous) || key && target[key] !== previous[key])) {
        $caa70d287a6ddb62$var$setProperty(parent, property, target);
        return;
    }
    if (Array.isArray(target)) {
        if (target.length && previous.length && (!merge || key && target[0] && target[0][key] != null)) {
            let i, j, start, end, newEnd, item, newIndicesNext, keyVal;
            for(start = 0, end = Math.min(previous.length, target.length); start < end && (previous[start] === target[start] || key && previous[start] && target[start] && previous[start][key] === target[start][key]); start++)$caa70d287a6ddb62$var$applyState(target[start], previous, start, merge, key);
            const temp = new Array(target.length), newIndices = new Map();
            for(end = previous.length - 1, newEnd = target.length - 1; end >= start && newEnd >= start && (previous[end] === target[newEnd] || key && previous[start] && target[start] && previous[end][key] === target[newEnd][key]); end--, newEnd--)temp[newEnd] = previous[end];
            if (start > newEnd || start > end) {
                for(j = start; j <= newEnd; j++)$caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
                for(; j < target.length; j++){
                    $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                    $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
                }
                if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
                return;
            }
            newIndicesNext = new Array(newEnd + 1);
            for(j = newEnd; j >= start; j--){
                item = target[j];
                keyVal = key && item ? item[key] : item;
                i = newIndices.get(keyVal);
                newIndicesNext[j] = i === undefined ? -1 : i;
                newIndices.set(keyVal, j);
            }
            for(i = start; i <= end; i++){
                item = previous[i];
                keyVal = key && item ? item[key] : item;
                j = newIndices.get(keyVal);
                if (j !== undefined && j !== -1) {
                    temp[j] = previous[i];
                    j = newIndicesNext[j];
                    newIndices.set(keyVal, j);
                }
            }
            for(j = start; j < target.length; j++)if (j in temp) {
                $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
            } else $caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
        } else for(let i = 0, len = target.length; i < len; i++)$caa70d287a6ddb62$var$applyState(target[i], previous, i, merge, key);
        if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
        return;
    }
    const targetKeys = Object.keys(target);
    for(let i = 0, len = targetKeys.length; i < len; i++)$caa70d287a6ddb62$var$applyState(target[targetKeys[i]], previous, targetKeys[i], merge, key);
    const previousKeys = Object.keys(previous);
    for(let i = 0, len = previousKeys.length; i < len; i++)if (target[previousKeys[i]] === undefined) $caa70d287a6ddb62$var$setProperty(previous, previousKeys[i], undefined);
}
function $caa70d287a6ddb62$export$38319cad1f6d89e0(value, options = {}) {
    const { merge: merge, key: key = "id" } = options, v = $caa70d287a6ddb62$export$debb760848ca95a(value);
    return (state)=>{
        if (!$caa70d287a6ddb62$var$isWrappable(state) || !$caa70d287a6ddb62$var$isWrappable(v)) return v;
        const res = $caa70d287a6ddb62$var$applyState(v, {
            [$caa70d287a6ddb62$var$$ROOT]: state
        }, $caa70d287a6ddb62$var$$ROOT, merge, key);
        return res === undefined ? state : res;
    };
}
const $caa70d287a6ddb62$var$producers = new WeakMap();
const $caa70d287a6ddb62$var$setterTraps = {
    get (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        const value = target[property];
        let proxy;
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$producers.get(value) || ($caa70d287a6ddb62$var$producers.set(value, proxy = new Proxy(value, $caa70d287a6ddb62$var$setterTraps)), proxy) : value;
    },
    set (target, property, value) {
        $caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value));
        return true;
    },
    deleteProperty (target, property) {
        $caa70d287a6ddb62$var$setProperty(target, property, undefined, true);
        return true;
    }
};
function $caa70d287a6ddb62$export$b46cabe22e78bc00(fn) {
    return (state)=>{
        if ($caa70d287a6ddb62$var$isWrappable(state)) {
            let proxy;
            if (!(proxy = $caa70d287a6ddb62$var$producers.get(state))) $caa70d287a6ddb62$var$producers.set(state, proxy = new Proxy(state, $caa70d287a6ddb62$var$setterTraps));
            fn(proxy);
        }
        return state;
    };
}
const $caa70d287a6ddb62$export$404582bc18fe4d9e = undefined;



const $059fd204a72364ff$var$AdminContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $059fd204a72364ff$export$66cafb854a568b29(props) {
    const [adminStore, setAdminStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        users: [],
        results: {},
        resultsFetching: false,
        pipelines: {},
        problems: [],
        problemsImporting: false,
        problemsImportMessage: null
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log("Mounted AdminContext");
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("user-list", (users)=>{
            setAdminStore({
                users: users
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("results", (results)=>{
            setAdminStore({
                results: results,
                resultsFetching: false
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("pipeline-triggered", (payload)=>{
            if (!payload) return;
            // lightweight feedback via console for now; could be extended to toasts
            if (payload.ok) console.log("Pipeline triggered for user", payload.user_id, payload.pipeline);
            else console.warn("Pipeline trigger failed for user", payload.user_id, payload.error);
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("pipelines-latest", (latest)=>{
            setAdminStore({
                pipelines: latest || {}
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("pipeline-updated", ({ user_id: user_id, pipeline: pipeline })=>{
            setAdminStore("pipelines", user_id, pipeline);
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("problem-list", (problems)=>{
            setAdminStore({
                problems: problems || []
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("problems-imported", (result)=>{
            setAdminStore({
                problemsImporting: false,
                problemsImportMessage: result.ok ? `${result.count} problèmes importés depuis le pipeline ${result.pipelineId}.` : result.error || "Import des probl\xe8mes impossible."
            });
        });
    });
    const actions = {
        editUser: (index)=>{
            const user = adminStore.users[index];
            const fields = {
                role: user.roleInput,
                project_id: user.project_idInput
            };
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("update-user", {
                id: user.id,
                fields: fields
            });
            setAdminStore("users", index, "editing", false);
        },
        deleteUser: (user_id)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("delete-user", user_id);
            setAdminStore("users", (u)=>u.filter((user)=>user.id !== user_id));
        },
        addUser: (fields)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("add-user", fields);
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($059fd204a72364ff$var$AdminContext.Provider, {
        value: [
            adminStore,
            setAdminStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $059fd204a72364ff$export$b3189d039b00bb0c() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($059fd204a72364ff$var$AdminContext);
}


const $27571a24c8d6ae26$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<a target="_blank">`), $27571a24c8d6ae26$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div class="mb-3"><label class="form-check-label me-3"><input type="checkbox" class="form-check-input me-1">Hide student names</label><small class="text-muted">Students are ordered by number of solved problems (ascending)</small></div><h3>Problèmes vérifiés</h3><div class="problems-table-wrapper"><table class="table table-bordered table-hove table-sm rotate problems"><thead><tr class="rotate"><th scope="col" class="student-col">Etudiant</th><th scope="col" class="student-col">Nb exos résolus</th></tr></thead><tbody></tbody></table></div><h3>Autres problèmes</h3><div class="problems-table-wrapper"><table class="table table-bordered table-hove table-sm rotate problems"><thead><tr class="rotate"><th scope="col" class="student-col">Etudiant</th></tr></thead><tbody>`), $27571a24c8d6ae26$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<th scope="col" class="rotate"><div><span>`), $27571a24c8d6ae26$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Loading...`), $27571a24c8d6ae26$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><th scope="row"></th><td class="student-col">`), $27571a24c8d6ae26$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<td>`), $27571a24c8d6ae26$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><th scope="row">`);
function $27571a24c8d6ae26$var$resultsToScore(results, options = {}) {
    let score = -1;
    for (const r of results){
        if (options.verified && r.date === "null") continue;
        let { exit_code: exit_code, note: note } = r;
        note = parseInt(note);
        if (exit_code == 0) {
            score = 100;
            break;
        }
        if (note > score) score = note;
    }
    if (score == 100) return "✓";
    if (score > 0) return score;
    return "❌";
}
const $27571a24c8d6ae26$var$User = (props)=>{
    return (()=>{
        const _el$ = $27571a24c8d6ae26$var$_tmpl$();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, ()=>props.hideNames ? `Student ${props.index + 1}` : props.user.username);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$, "href", props.user.project_url));
        return _el$;
    })();
};
// Function to count solved problems for a user
function $27571a24c8d6ae26$var$countSolvedProblems(user, verifiedProblems, problems) {
    let count = 0;
    // Count verified problems
    Object.keys(verifiedProblems).forEach((problemName)=>{
        if (verifiedProblems[problemName][user.username]) {
            const score = $27571a24c8d6ae26$var$resultsToScore(verifiedProblems[problemName][user.username], {
                verified: true
            });
            if (score === "✓") count++;
        }
    });
    // Count other problems
    Object.keys(problems).forEach((problemName)=>{
        if (problems[problemName][user.username]) {
            const score = $27571a24c8d6ae26$var$resultsToScore(problems[problemName][user.username]);
            if (score === "✓") count++;
        }
    });
    return count;
}
var $27571a24c8d6ae26$export$2e2bcd8739ae039 /*
  <tbody>
    {filtered().users.sort((a,b) => a.username.localeCompare(b.username)).filter(a => a.username != 'bramas' && a.username != 'dufresnee').map(({status, username, results}) => (
                  <tr key={username}>
                    <th scope="row" class={"student-col status-"+status}>{username} <a href={GITLAB_REPO_URL.replace('{namespace}', state.project.namespace.path).replace('{name}', username.replace('.','-'))} target="_blank">r</a></th>
                    {
                      Object.keys(filtered().verifiedProblems).sort().map((problem_name) => (
                        <td>{(filtered().verifiedProblems[problem_name][username] 
                          && parseInt(filtered().verifiedProblems[problem_name][username])) || '0'}</td>
                      ))
                    }
                  </tr>)
    )}
  </tbody>
</table>
</div>
<h3>Autres problèmes</h3>
<div class="problems-table-wrapper">
<table class="table table-bordered table-hove table-sm rotate problems">
  <thead>
    <tr class="rotate">
      <th scope="col" class="student-col" style={{zIndex:100001}}>Etudiant</th>{
        Object.keys(filtered().problems).sort().map((problem_name, i) => (
          <th scope="col" class="rotate" style={{zIndex:100000-i}}><div><span>{problem_name}</span></div></th>
        ))
      }
    </tr>
  </thead>
  <tbody>
    {filtered().users.map(({status, username, results}) => (
                  <tr key={username}>
                    <th scope="row" class={"student-col status-"+status}>{username}</th>
                    {
                      Object.keys(filtered().problems).sort().map((problem_name) => (
                        <td>{filtered().problems[problem_name][username] === undefined
                        ? '' :
                        ( parseInt(filtered().problems[problem_name][username])
                          ?'✓':'❌'
                        )}</td>
                      ))
                    }
                  </tr>)
    )}
  </tbody>
</table>
</div>
</div>
}*/  = ()=>{
    const [hideNames, setHideNames] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(true); // Hidden by default
    const [adminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const filtered = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const currentYear = new Date().getFullYear();
        const results = adminStore.results;
        const verifiedProblems = {};
        const problems = {};
        const users = adminStore.users.filter(({ username: username })=>results[username]);
        Object.keys(results).forEach((username)=>{
            results[username].forEach((p)=>{
                const problem_name = p.problem_name || p.folder;
                if (p.verified_problem_name !== "null" && p.deadline.localeCompare(currentYear) >= 0) {
                    if (!verifiedProblems[problem_name]) verifiedProblems[problem_name] = {};
                    verifiedProblems[problem_name][username] = p.results || null;
                } else {
                    if (!problems[problem_name]) problems[problem_name] = {};
                    problems[problem_name][username] = p.results || null;
                }
            });
        });
        // Sort users by number of solved problems (ascending)
        const sortedUsers = users.sort((a, b)=>{
            const countA = $27571a24c8d6ae26$var$countSolvedProblems(a, verifiedProblems, problems);
            const countB = $27571a24c8d6ae26$var$countSolvedProblems(b, verifiedProblems, problems);
            return countA - countB; // Ascending order
        });
        console.log({
            verifiedProblems: verifiedProblems,
            problems: problems,
            users: sortedUsers
        });
        return {
            verifiedProblems: verifiedProblems,
            problems: problems,
            users: sortedUsers
        };
    });
    return (()=>{
        const _el$2 = $27571a24c8d6ae26$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.firstChild, _el$6 = _el$3.nextSibling, _el$7 = _el$6.nextSibling, _el$8 = _el$7.firstChild, _el$9 = _el$8.firstChild, _el$10 = _el$9.firstChild, _el$11 = _el$10.firstChild, _el$12 = _el$11.nextSibling, _el$13 = _el$9.nextSibling, _el$14 = _el$7.nextSibling, _el$15 = _el$14.nextSibling, _el$16 = _el$15.firstChild, _el$17 = _el$16.firstChild, _el$18 = _el$17.firstChild, _el$19 = _el$18.firstChild, _el$20 = _el$17.nextSibling;
        _el$5.addEventListener("change", (e)=>setHideNames(e.target.checked));
        _el$11.style.setProperty("z-index", "100001");
        _el$12.style.setProperty("z-index", "100000");
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>Object.keys(filtered().verifiedProblems).sort().map((problem_name, i)=>(()=>{
                    const _el$21 = $27571a24c8d6ae26$var$_tmpl$3(), _el$22 = _el$21.firstChild, _el$23 = _el$22.firstChild;
                    _el$21.style.setProperty("z-index", 99999 - i);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, problem_name);
                    return _el$21;
                })()), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return filtered().users;
            },
            get fallback () {
                return $27571a24c8d6ae26$var$_tmpl$4();
            },
            children: (item, index)=>(()=>{
                    const _el$25 = $27571a24c8d6ae26$var$_tmpl$5(), _el$26 = _el$25.firstChild, _el$27 = _el$26.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($27571a24c8d6ae26$var$User, {
                        user: item,
                        get hideNames () {
                            return hideNames();
                        },
                        get index () {
                            return index();
                        }
                    }));
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>Object.keys(filtered().problems).reduce((count, problemName)=>{
                            if (filtered().problems[problemName][item.username]) {
                                const score = $27571a24c8d6ae26$var$resultsToScore(filtered().problems[problemName][item.username]);
                                if (score === "✓") count++;
                            }
                            return count;
                        }, 0));
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                        get each () {
                            return Object.keys(filtered().verifiedProblems).sort();
                        },
                        children: (problem_name)=>(()=>{
                                const _el$28 = $27571a24c8d6ae26$var$_tmpl$6();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, (()=>{
                                    const _c$ = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!filtered().verifiedProblems[problem_name][item.username]);
                                    return ()=>_c$() ? $27571a24c8d6ae26$var$resultsToScore(filtered().verifiedProblems[problem_name][item.username], {
                                            verified: true
                                        }) : " ";
                                })());
                                return _el$28;
                            })()
                    }), null);
                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$26, "student-col status-" + item.status));
                    return _el$25;
                })()
        }));
        _el$19.style.setProperty("z-index", "100001");
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, ()=>Object.keys(filtered().problems).sort().map((problem_name, i)=>(()=>{
                    const _el$29 = $27571a24c8d6ae26$var$_tmpl$3(), _el$30 = _el$29.firstChild, _el$31 = _el$30.firstChild;
                    _el$29.style.setProperty("z-index", 100000 - i);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, problem_name);
                    return _el$29;
                })()), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return filtered().users;
            },
            get fallback () {
                return $27571a24c8d6ae26$var$_tmpl$4();
            },
            children: (item, index)=>(()=>{
                    const _el$33 = $27571a24c8d6ae26$var$_tmpl$7(), _el$34 = _el$33.firstChild;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$34, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($27571a24c8d6ae26$var$User, {
                        user: item,
                        get hideNames () {
                            return hideNames();
                        },
                        get index () {
                            return index();
                        }
                    }));
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                        get each () {
                            return Object.keys(filtered().problems).sort();
                        },
                        children: (problem_name)=>(()=>{
                                const _el$35 = $27571a24c8d6ae26$var$_tmpl$6();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, (()=>{
                                    const _c$2 = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!filtered().problems[problem_name][item.username]);
                                    return ()=>_c$2() ? $27571a24c8d6ae26$var$resultsToScore(filtered().problems[problem_name][item.username]) : " ";
                                })());
                                return _el$35;
                            })()
                    }), null);
                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$34, "student-col status-" + item.status));
                    return _el$33;
                })()
        }));
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$5.checked = hideNames());
        return _el$2;
    })();
};





const $dd67cc782607ead6$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type="button" class="btn btn btn-primary btn-sm">Add User`), $dd67cc782607ead6$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table class="table table-striped table-hover"><thead><tr><th scope="col">Id</th><th scope="col">Username</th><th scope="col">Role</th><th scope="col">Project Id</th><th scope="col">Actions</th></tr></thead><tbody>`), $dd67cc782607ead6$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input class="form-control">`), $dd67cc782607ead6$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type="button" class="btn btn btn-outline-primary btn-sm">save`), $dd67cc782607ead6$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type="button" class="btn btn btn-outline-info btn-sm">edit`), $dd67cc782607ead6$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td scope="row"></td><td></td><td></td><td></td><td> <button type="button" class="btn btn btn-outline-danger btn-sm">delete`);
var $dd67cc782607ead6$export$2e2bcd8739ae039 = (props)=>{
    const [adminStore, setAdminStore, { editUser: editUser, deleteUser: deleteUser, addUser: addUser }] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    //console.log(adminStore, setAdminStore);
    return [
        (()=>{
            const _el$ = $dd67cc782607ead6$var$_tmpl$(), _el$2 = _el$.firstChild;
            _el$2.$$click = ()=>{
                const username = prompt("username", "");
                addUser({
                    username: username,
                    role: "student"
                });
            };
            return _el$;
        })(),
        (()=>{
            const _el$3 = $dd67cc782607ead6$var$_tmpl$2(), _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                get each () {
                    return adminStore.users;
                },
                children: (user, index)=>(()=>{
                        const _el$6 = $dd67cc782607ead6$var$_tmpl$6(), _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$11 = _el$9.nextSibling, _el$13 = _el$11.nextSibling, _el$16 = _el$13.firstChild, _el$17 = _el$16.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>user.id);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>user.username);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return user.role;
                            },
                            get children () {
                                const _el$10 = $dd67cc782607ead6$var$_tmpl$3();
                                _el$10.$$input = (e)=>setAdminStore("users", index(), {
                                        roleInput: e.target.value
                                    });
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$10.value = user.roleInput);
                                return _el$10;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return user.project_id;
                            },
                            get children () {
                                const _el$12 = $dd67cc782607ead6$var$_tmpl$3();
                                _el$12.$$input = (e)=>setAdminStore("users", index(), {
                                        project_idInput: e.target.value
                                    });
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$12.value = user.project_idInput);
                                return _el$12;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get children () {
                                const _el$14 = $dd67cc782607ead6$var$_tmpl$4();
                                _el$14.$$click = ()=>editUser(index());
                                return _el$14;
                            }
                        }), _el$16);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return !user.editing;
                            },
                            get children () {
                                const _el$15 = $dd67cc782607ead6$var$_tmpl$5();
                                _el$15.$$click = ()=>setAdminStore("users", index(), {
                                        editing: true,
                                        roleInput: user.role,
                                        project_idInput: user.project_id
                                    });
                                return _el$15;
                            }
                        }), _el$16);
                        _el$17.$$click = ()=>{
                            if (confirm("Confirm deletion")) deleteUser(user.id);
                        };
                        return _el$6;
                    })()
            }));
            return _el$3;
        })()
    ];
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);






const $5ddd5c0d2d2b1a27$export$e0951c0540b52d1e = "Europe/Paris";
const $5ddd5c0d2d2b1a27$var$partsFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: $5ddd5c0d2d2b1a27$export$e0951c0540b52d1e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23"
});
const $5ddd5c0d2d2b1a27$var$partsAt = (timestamp)=>Object.fromEntries($5ddd5c0d2d2b1a27$var$partsFormatter.formatToParts(new Date(timestamp)).filter((part)=>part.type !== "literal").map((part)=>[
            part.type,
            Number(part.value)
        ]));
function $5ddd5c0d2d2b1a27$export$cc51115cf96d77ad(value) {
    if (!value) return {
        date: "",
        time: ""
    };
    const timestamp = new Date(value).valueOf();
    if (Number.isNaN(timestamp)) return {
        date: "",
        time: ""
    };
    const parts = $5ddd5c0d2d2b1a27$var$partsAt(timestamp);
    const pad = (number)=>String(number).padStart(2, "0");
    return {
        date: `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`,
        time: `${pad(parts.hour)}:${pad(parts.minute)}`
    };
}
function $5ddd5c0d2d2b1a27$export$ba0465c2193edbae(date, time) {
    const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(`${date} ${time}`);
    if (!match) return null;
    const expected = {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
        hour: Number(match[4]),
        minute: Number(match[5]),
        second: 0
    };
    const wallClockAsUtc = Date.UTC(expected.year, expected.month - 1, expected.day, expected.hour, expected.minute);
    let timestamp = wallClockAsUtc;
    for(let attempt = 0; attempt < 3; attempt += 1){
        const parts = $5ddd5c0d2d2b1a27$var$partsAt(timestamp);
        const offset = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - timestamp;
        timestamp = wallClockAsUtc - offset;
    }
    const actual = $5ddd5c0d2d2b1a27$var$partsAt(timestamp);
    if (Object.keys(expected).some((key)=>actual[key] !== expected[key])) return null;
    return new Date(timestamp).toISOString();
}
function $5ddd5c0d2d2b1a27$export$ee4a7170d72f1e73(value) {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.valueOf())) return "Date invalide";
    return new Intl.DateTimeFormat("fr-FR", {
        timeZone: $5ddd5c0d2d2b1a27$export$e0951c0540b52d1e,
        dateStyle: "short",
        timeStyle: "short"
    }).format(date);
}


const $e25e502746ee9f7f$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type="button" class="btn btn-outline-secondary btn-sm" title="Utiliser la même date et la même heure que la ligne précédente">↑ Même date`), $e25e502746ee9f7f$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type="button" class="btn btn-link btn-sm p-0">Réinitialiser`), $e25e502746ee9f7f$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="small text-danger">`), $e25e502746ee9f7f$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="starting-date-editor"><div class="d-flex flex-wrap gap-2 align-items-center"><input type="date" class="form-control form-control-sm starting-date-editor__date" aria-label="Date de début, heure de Paris"><input type="time" class="form-control form-control-sm starting-date-editor__time" aria-label="Heure de début, heure de Paris" step="300">`);
function $e25e502746ee9f7f$export$2e2bcd8739ae039(props) {
    const [date, setDate] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [time, setTime] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [error, setError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        const fields = (0, $5ddd5c0d2d2b1a27$export$cc51115cf96d77ad)(props.overrideValue || props.defaultValue);
        setDate(fields.date);
        setTime(fields.time);
        setError("");
    });
    const save = (nextDate = date(), nextTime = time())=>{
        const iso = (0, $5ddd5c0d2d2b1a27$export$ba0465c2193edbae)(nextDate, nextTime);
        if (!iso) {
            if (nextDate && nextTime) setError("Date ou heure invalide.");
            return;
        }
        setError("");
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("set-problem-starting-date", {
            problemKey: props.problemKey,
            startingDateOverride: iso
        });
    };
    const copyPrevious = ()=>{
        const fields = (0, $5ddd5c0d2d2b1a27$export$cc51115cf96d77ad)(props.previousValue);
        setDate(fields.date);
        setTime(fields.time);
        save(fields.date, fields.time);
    };
    return (()=>{
        const _el$ = $e25e502746ee9f7f$var$_tmpl$4(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
        _el$3.addEventListener("change", (event)=>{
            setDate(event.currentTarget.value);
            save(event.currentTarget.value, time());
        });
        _el$4.addEventListener("change", (event)=>{
            setTime(event.currentTarget.value);
            save(date(), event.currentTarget.value);
        });
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.previousValue;
            },
            get children () {
                const _el$5 = $e25e502746ee9f7f$var$_tmpl$();
                _el$5.$$click = copyPrevious;
                return _el$5;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.hasOverride;
            },
            get children () {
                const _el$6 = $e25e502746ee9f7f$var$_tmpl$2();
                _el$6.$$click = ()=>(0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("set-problem-starting-date", {
                        problemKey: props.problemKey,
                        startingDateOverride: null
                    });
                return _el$6;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return error();
            },
            get children () {
                const _el$7 = $e25e502746ee9f7f$var$_tmpl$3();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, error);
                return _el$7;
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$3.value = date());
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$4.value = time());
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);



const $e4c7899627fd74c8$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<ul class="nav nav-tabs"><li class="nav-item"><a aria-current="page" href="#">Liste Etudiants</a></li><li class="nav-item"><a href="#">Tableaux des résultats</a></li><li class="nav-item"><a href="#">Liste des Utilisateurs</a></li><li class="nav-item"><a href="#">Problèmes`), $e4c7899627fd74c8$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table><thead><tr><th>#</th><th>Username</th><th>Repo</th><th>Last pipeline</th><th>Actions</th></tr></thead><tbody>`), $e4c7899627fd74c8$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type="button" class="btn btn btn-primary btn-sm">Refresh Results</button><small class="text-muted ms-2">Results are automatically updated when pipelines complete`), $e4c7899627fd74c8$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Refreshing results...`), $e4c7899627fd74c8$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>No results available yet. Results will appear automatically when students complete their assignments.`), $e4c7899627fd74c8$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="small">`), $e4c7899627fd74c8$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mb-3 d-flex align-items-center gap-2"><button type="button" class="btn btn-primary btn-sm">`), $e4c7899627fd74c8$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table class="table table-sm"><thead><tr><th>Problème</th><th>Date de début</th><th>Dernière mise à jour</th><th>Alertes</th></tr></thead><tbody>`), $e4c7899627fd74c8$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Loading...`), $e4c7899627fd74c8$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td> </td><td></td><td></td><td><button type="button" class="btn btn-sm btn-outline-secondary">Trigger pipeline`), $e4c7899627fd74c8$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<a target="_blank">`), $e4c7899627fd74c8$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span>`), $e4c7899627fd74c8$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td colspan="4">Aucun problème importé.`), $e4c7899627fd74c8$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-warning">Absent du dernier pipeline`), $e4c7899627fd74c8$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-danger">Date de début invalide ou vieille de plus de 6 mois`), $e4c7899627fd74c8$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-info">Date remplacée par un administrateur`), $e4c7899627fd74c8$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td></td><td>`);
function $e4c7899627fd74c8$export$2e2bcd8739ae039() {
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [activeTab, setActiveTab] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("Liste Etudiants");
    const tabClass = (tabName)=>{
        return activeTab() === tabName ? "nav-link active" : "nav-link";
    };
    const handleTabClick = (tabName)=>(event)=>{
            setActiveTab(tabName);
            event.preventDefault();
        };
    return [
        (()=>{
            const _el$ = $e4c7899627fd74c8$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$2.nextSibling, _el$5 = _el$4.firstChild, _el$6 = _el$4.nextSibling, _el$7 = _el$6.firstChild, _el$8 = _el$6.nextSibling, _el$9 = _el$8.firstChild;
            (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$3, "click", handleTabClick("Liste Etudiants"), true);
            (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$5, "click", handleTabClick("Tableaux des r\xe9sultats"), true);
            (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$7, "click", handleTabClick("Liste des Utilisateurs"), true);
            (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$9, "click", handleTabClick("Probl\xe8mes"), true);
            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                const _v$ = tabClass("Liste Etudiants"), _v$2 = tabClass("Tableaux des r\xe9sultats"), _v$3 = tabClass("Liste des Utilisateurs"), _v$4 = tabClass("Probl\xe8mes");
                _v$ !== _p$._v$ && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$3, _p$._v$ = _v$);
                _v$2 !== _p$._v$2 && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$5, _p$._v$2 = _v$2);
                _v$3 !== _p$._v$3 && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$7, _p$._v$3 = _v$3);
                _v$4 !== _p$._v$4 && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$9, _p$._v$4 = _v$4);
                return _p$;
            }, {
                _v$: undefined,
                _v$2: undefined,
                _v$3: undefined,
                _v$4: undefined
            });
            return _el$;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$b5d5cf8927ab7262), {
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return adminStore.users;
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                                get when () {
                                    return activeTab() === "Liste Etudiants";
                                },
                                get children () {
                                    const _el$10 = $e4c7899627fd74c8$var$_tmpl$2(), _el$11 = _el$10.firstChild, _el$12 = _el$11.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return adminStore.users;
                                        },
                                        get fallback () {
                                            return $e4c7899627fd74c8$var$_tmpl$9();
                                        },
                                        children: (item, index)=>(()=>{
                                                const _el$24 = $e4c7899627fd74c8$var$_tmpl$10(), _el$25 = _el$24.firstChild, _el$26 = _el$25.nextSibling, _el$27 = _el$26.firstChild, _el$28 = _el$26.nextSibling, _el$29 = _el$28.nextSibling, _el$30 = _el$29.nextSibling, _el$31 = _el$30.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, ()=>index() + 1);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, ()=>item.username, _el$27);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, ()=>item.role === "admin" ? "\uD83D\uDC51" : "", null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, (()=>{
                                                    const _c$ = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!!item.project_id);
                                                    return ()=>_c$() ? (()=>{
                                                            const _el$32 = $e4c7899627fd74c8$var$_tmpl$11();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>item.project_url);
                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$32, "href", item.project_url));
                                                            return _el$32;
                                                        })() : "No project";
                                                })());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return adminStore.pipelines && adminStore.pipelines[item.id];
                                                    },
                                                    fallback: "—",
                                                    get children () {
                                                        return (()=>{
                                                            const p = adminStore.pipelines[item.id];
                                                            const status = p?.status || "unknown";
                                                            const color = status === "success" ? "green" : status === "failed" ? "red" : status === "running" ? "orange" : "gray";
                                                            return (()=>{
                                                                const _el$33 = $e4c7899627fd74c8$var$_tmpl$12();
                                                                color != null ? _el$33.style.setProperty("color", color) : _el$33.style.removeProperty("color");
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, status);
                                                                return _el$33;
                                                            })();
                                                        })();
                                                    }
                                                }));
                                                _el$31.$$click = ()=>{
                                                    const ref = "master";
                                                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("trigger-pipeline", {
                                                        user_id: item.id,
                                                        ref: ref
                                                    });
                                                };
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$31.disabled = !item.project_id);
                                                return _el$24;
                                            })()
                                    }));
                                    return _el$10;
                                }
                            });
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                        get when () {
                            return activeTab() === "Tableaux des r\xe9sultats";
                        },
                        get children () {
                            return [
                                (()=>{
                                    const _el$13 = $e4c7899627fd74c8$var$_tmpl$3(), _el$14 = _el$13.firstChild;
                                    _el$14.$$click = ()=>{
                                        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("fetch-results");
                                        setAdminStore("resultsFetching", true);
                                    };
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$14.disabled = adminStore.resultsFetching);
                                    return _el$13;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return adminStore.results && adminStore.users;
                                    },
                                    get children () {
                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $27571a24c8d6ae26$export$2e2bcd8739ae039), {});
                                    }
                                }),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return adminStore.resultsFetching;
                                    },
                                    get children () {
                                        return $e4c7899627fd74c8$var$_tmpl$4();
                                    }
                                }),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return !adminStore.results && !adminStore.resultsFetching;
                                    },
                                    get children () {
                                        return $e4c7899627fd74c8$var$_tmpl$5();
                                    }
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                        get when () {
                            return activeTab() === "Liste des Utilisateurs";
                        },
                        get children () {
                            return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $dd67cc782607ead6$export$2e2bcd8739ae039), {});
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                        get when () {
                            return activeTab() === "Probl\xe8mes";
                        },
                        get children () {
                            return [
                                (()=>{
                                    const _el$17 = $e4c7899627fd74c8$var$_tmpl$7(), _el$18 = _el$17.firstChild;
                                    _el$18.$$click = ()=>{
                                        setAdminStore({
                                            problemsImporting: true,
                                            problemsImportMessage: null
                                        });
                                        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("import-latest-problems");
                                    };
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, ()=>adminStore.problemsImporting ? "Import en cours..." : "Importer le dernier pipeline");
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return adminStore.problemsImportMessage;
                                        },
                                        get children () {
                                            const _el$19 = $e4c7899627fd74c8$var$_tmpl$6();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>adminStore.problemsImportMessage);
                                            return _el$19;
                                        }
                                    }), null);
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$18.disabled = adminStore.problemsImporting);
                                    return _el$17;
                                })(),
                                (()=>{
                                    const _el$20 = $e4c7899627fd74c8$var$_tmpl$8(), _el$21 = _el$20.firstChild, _el$22 = _el$21.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return adminStore.problems;
                                        },
                                        get fallback () {
                                            return $e4c7899627fd74c8$var$_tmpl$13();
                                        },
                                        children: (problem, index)=>(()=>{
                                                const _el$35 = $e4c7899627fd74c8$var$_tmpl$17(), _el$36 = _el$35.firstChild, _el$37 = _el$36.nextSibling, _el$38 = _el$37.nextSibling, _el$39 = _el$38.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>problem.problem_key);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e25e502746ee9f7f$export$2e2bcd8739ae039), {
                                                    get problemKey () {
                                                        return problem.problem_key;
                                                    },
                                                    get defaultValue () {
                                                        return problem.default_starting_date;
                                                    },
                                                    get overrideValue () {
                                                        return problem.starting_date_override;
                                                    },
                                                    get hasOverride () {
                                                        return problem.has_starting_date_override;
                                                    },
                                                    get previousValue () {
                                                        return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>index() > 0)() ? adminStore.problems[index() - 1].effective_starting_date : null;
                                                    }
                                                }));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, ()=>(0, $5ddd5c0d2d2b1a27$export$ee4a7170d72f1e73)(problem.last_updated.replace(" ", "T") + "Z"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return problem.missing_from_latest_pipeline;
                                                    },
                                                    get children () {
                                                        return $e4c7899627fd74c8$var$_tmpl$14();
                                                    }
                                                }), null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return problem.starting_date_too_old;
                                                    },
                                                    get children () {
                                                        return $e4c7899627fd74c8$var$_tmpl$15();
                                                    }
                                                }), null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return problem.has_starting_date_override;
                                                    },
                                                    get children () {
                                                        return $e4c7899627fd74c8$var$_tmpl$16();
                                                    }
                                                }), null);
                                                return _el$35;
                                            })()
                                    }));
                                    return _el$20;
                                })()
                            ];
                        }
                    })
                ];
            }
        })
    ];
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);




const $bd3f6eae7d713afc$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h1>`), $bd3f6eae7d713afc$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type="button" class="btn btn-primary">Se connecter`), $bd3f6eae7d713afc$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Veuillez contacter l'enseignant.`), $bd3f6eae7d713afc$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>Access Token: <input type="text"> <button>Submit`), $bd3f6eae7d713afc$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<br>`), $bd3f6eae7d713afc$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<pre>`);
function $bd3f6eae7d713afc$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({
        username: "",
        role: "",
        project: "",
        creatingProject: false,
        gitlab_not_ready: false
    });
    const [log, setLog] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log("Mounted App");
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("authenticated", ({ username: username, role: role })=>{
            console.log({
                username: username,
                role: role
            });
            setState({
                ...state(),
                username: username,
                role: role
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("gitlab-not-ready", ()=>{
            console.log("gitlab-not-ready");
            setState({
                ...state(),
                gitlab_not_ready: true
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("gitlab-ready", ()=>{
            console.log("gitlab-ready");
            setState({
                ...state(),
                gitlab_not_ready: false
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("project", (project)=>{
            console.log(project);
            setState({
                ...state(),
                project: project,
                creatingProject: false
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("project-log", (_log)=>{
            console.log(_log);
            setLog(log() + "\n" + _log);
        });
    });
    function createProject(data, event) {
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("create-project");
        setState({
            ...state(),
            creatingProject: true
        });
    }
    const [accessTokenInput, setAccessTokenInput] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    function onAccessTokenChange(event) {
        console.log(event.target.value);
        setAccessTokenInput(event.target.value);
    }
    function submitAccessToken(event) {
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("access-token", accessTokenInput());
    }
    return [
        (()=>{
            const _el$ = $bd3f6eae7d713afc$var$_tmpl$();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, ()=>state().username || "Non connect\xe9");
            return _el$;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !state().username;
            },
            get children () {
                const _el$2 = $bd3f6eae7d713afc$var$_tmpl$2();
                _el$2.$$click = ()=>{
                    location.href = "/login";
                };
                return _el$2;
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return state().gitlab_not_ready;
            },
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return state().role == "student";
                        },
                        get children () {
                            return $bd3f6eae7d713afc$var$_tmpl$3();
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return state().role == "admin";
                        },
                        get children () {
                            const _el$4 = $bd3f6eae7d713afc$var$_tmpl$4(), _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling, _el$7 = _el$6.nextSibling, _el$8 = _el$7.nextSibling;
                            _el$6.$$input = onAccessTokenChange;
                            _el$8.$$click = submitAccessToken;
                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$6.value = accessTokenInput());
                            return _el$4;
                        }
                    })
                ];
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return state().project;
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $0ab46d09fa7ca2c2$export$a64da8fc8b9c1af9), {
                    state: state,
                    createProject: createProject
                });
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>state().role === "admin")() && !state().gitlab_not_ready;
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $059fd204a72364ff$export$66cafb854a568b29), {
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e4c7899627fd74c8$export$2e2bcd8739ae039), {});
                    }
                });
            }
        }),
        $bd3f6eae7d713afc$var$_tmpl$5(),
        (()=>{
            const _el$10 = $bd3f6eae7d713afc$var$_tmpl$6();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, log);
            return _el$10;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $a26018a1d2174fbf$export$d049364d16567d0d), {})
    ];
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);


const $5a283b6fa3b36b50$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div class="container"></div><footer class="footer"><div class="container"><span class="text-muted"><a href="http://bramas.fr">bramas.fr</a></span> | <span class="text-muted"><a href="#">Se déconnecter`);
const $5a283b6fa3b36b50$var$app = document.getElementById("app");
if ($5a283b6fa3b36b50$var$app) (0, $6258376c5c54faa9$export$b3890eb0ae9dca99)(()=>(()=>{
        const _el$ = $5a283b6fa3b36b50$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling, _el$7 = _el$6.nextSibling, _el$8 = _el$7.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $bd3f6eae7d713afc$export$2e2bcd8739ae039), {}));
        _el$3.style.setProperty("display", "none");
        _el$8.$$click = ()=>{};
        return _el$;
    })(), $5a283b6fa3b36b50$var$app);
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);


//# sourceMappingURL=index.db502fee.js.map
